<template>
    <v-container grid-list-md fluid>
        <!-- ++ barre commune -->
        <v-row class="d-flex justify-space-between mb-1" v-if="inAuditReport">
            <v-col cols="6" class="d-flex flex-column">
                <v-row no-gutters>
                    <v-col cols="1" class="d-flex align-center justify-center">
                        <v-btn-back @click="$router.push({ name: 'auditReport' })" />
                    </v-col>
                    <v-col cols="11" class="d-flex align-center">
                        <h2 v-if="!documentId">Immobilisations et amortissements</h2>
                        <h2 v-else-if="documentId">
                            Extrait des immobilisations à amortir rattachées au document
                        </h2>
                        <h2 v-else-if="bankTransactionId">
                            Extrait des immobilisations à amortir rattachées au mouvement bancaire
                        </h2>
                        <h2 v-else-if="accountingLineId">
                            Extrait des immobilisations à amortir rattachées à l'écriture comptable
                        </h2>
                        <v-tooltip
                            v-if="!documentId && !bankTransactionId && !accountingLineId"
                            location="bottom"
                        >
                            <template v-slot:activator="{ props }">
                                <v-btn-icon
                                    v-bind="props"
                                    size="large"
                                    class="ml-2"
                                    icon="$oss-help"
                                />
                            </template>

                            <h4 class="mt-2">
                                IMMOBILISATIONS MISES EN SERVICE AU COURS DE PERIODES CLOTUREES
                            </h4>
                            <p>Utiliser le contrôle "Reprise des amortissements précédents".</p>
                            <h4 class="mt-2 mb-0">ACHATS N</h4>
                            <p class="mb-2">
                                Attention : tant que les tableaux d'amortissement ne seront pas
                                générés, les charges relatives aux lignes affichées
                                n'appara&#xee;tront pas dans le tableau de bord.
                            </p>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row no-gutters>
                    <v-col cols="1" />
                    <v-col cols="10">
                        {{ `Statut : ${checkStatus}` }}
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="6">
                <v-row no-gutters class="d-flex justify-end align-center">
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="dialogAuditCheckDocumentsManager = true"
                                v-on="props"
                                size="x-small"
                                icon="$oss-upload"
                            >
                            </v-btn>
                        </template>
                        <span>Lier un document</span>
                    </v-tooltip>
                    <!-- ** chat -->
                    <v-tooltip location="bottom" text="Message">
                        <template v-slot:activator="{ props }">
                            <v-btn
                                @click="openChat = !openChat"
                                v-bind="props"
                                size="x-small"
                                icon="$oss-chat"
                                class="mx-1"
                            />
                        </template>
                    </v-tooltip>

                    <!-- ** store -->
                    <v-btn
                        :disabled="
                            closedPeriod || validated || loading || dataLoading || !accountingPeriod
                        "
                        @click="storeComments()"
                        size="small"
                        class="mx-1"
                    >
                        Enregistrer
                    </v-btn>

                    <!-- ** validate -->
                    <v-btn
                        :disabled="
                            disabledBtnGlobalValidation ||
                            loading ||
                            dataLoading ||
                            !accountingPeriod
                        "
                        @click="validateFunction()"
                        size="small"
                        class="mx-1"
                    >
                        {{ validated ? "Invalider" : "Valider" }}
                    </v-btn>

                    <template v-if="isEnableReview">
                        <div
                            style="
                                border-right: 2px solid black;
                                width: 2px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />

                        <v-icon
                            :disabled="
                                reviewed === 1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-up"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = 1;
                                storeComments('REVIEW');
                            "
                        />
                        <v-icon
                            :disabled="
                                reviewed === -1 ||
                                !isEnableReview ||
                                !validated ||
                                loading ||
                                dataLoading
                            "
                            size="small"
                            icon="$fa-thumbs-down"
                            color="primary"
                            class="mx-1"
                            @click="
                                reviewed = -1;
                                storeComments('REVIEW');
                            "
                        />

                        <div
                            style="
                                border-right: 2px solid black;
                                width: 1px;
                                height: 25px;
                                margin: 0 4px;
                            "
                        />
                    </template>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-prev
                                v-bind="props"
                                :disabled="!previousControl"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToPreviousControl();
                                "
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle précédent :
                            {{
                                previousControl && previousControl.title
                                    ? previousControl.title
                                    : ""
                            }}
                        </div>
                    </v-tooltip>
                    <v-tooltip location="bottom">
                        <template v-slot:activator="{ props }">
                            <v-btn-next
                                v-bind="props"
                                @click="
                                    reviewed = 0;
                                    openChat = false;
                                    goToNextControl();
                                "
                                :disabled="!nextControl"
                            />
                        </template>
                        <div style="width: 400px" class="d-flex justify-center">
                            Contrôle suivant :
                            {{ nextControl && nextControl.title ? nextControl.title : "" }}
                        </div>
                    </v-tooltip>
                    <div
                        style="
                            border-right: 2px solid black;
                            width: 1px;
                            height: 25px;
                            margin: 0 4px;
                        "
                    />
                    <v-menu offset-y>
                        <template v-slot:activator="{ props }">
                            <v-btn-icon
                                icon="$dots_vertical"
                                v-bind="props"
                                class="mx-1"
                                color="primary"
                            />
                        </template>
                        <v-list nav>
                            <v-list-item @click="displayActivityDialog = true">
                                <v-list-item-title>Afficher l'activité</v-list-item-title>
                                <template v-slot:append>
                                    <v-icon>$oss-activity</v-icon>
                                </template>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-row>
            </v-col>
        </v-row>

        <div style="border-top-left-radius: 25px; border-top-right-radius: 25px">
            <!-- ** progress bar -->
            <template v-if="loading || dataLoading">
                <v-card
                    elevation="0"
                    style="background-color: #ffffff; border-radius: 25px; margin-top: 10px"
                >
                    <v-card-title class="pa-4 d-flex justify-center">
                        <v-progress-circular indeterminate class="mr-3" />
                    </v-card-title>
                </v-card>
            </template>

            <!-- ** no accountingPeriod -->
            <template v-else-if="!accountingPeriod">
                <v-row no-gutters class="d-flex flex-column justify-center align-center mb-3">
                    <v-icon class="mr-2 mb-1" size="large"> $oss-warning </v-icon>
                    <h3>Aucune période sélectionnée</h3>
                </v-row>
            </template>

            <!-- ** control -->
            <template v-else>
                <!-- <v-card-title class="px-0 py-2" v-if="!documentId && !bankTransactionId && !accountingLineId">
                    <v-row no-gutters class="pb-6">
                        <v-col cols="auto">
                            <h3>
                                Toutes périodes confondues, jusqu'au {{formatDate(accountingPeriod.end)}}
                            </h3>
                        </v-col>
                    </v-row>
                </v-card-title> -->

                <!-- ** no switch if no accountingPeriods -->
                <div v-if="!accountingPeriods">
                    <v-card-subtitle>
                        <h2 style="padding-top: 10px; color: red">
                            Aucune période fiscale n'a été créée
                        </h2>
                        <h3 style="padding-top: 10px">
                            Procédure : Mon client / onglet "Exercices"
                        </h3>
                        <h3 style="padding-top: 10px">
                            Il est indispensable de marquer les périodes clôturées, afin de ne pas
                            créer des doublons de dotations d'amortissement
                        </h3>
                    </v-card-subtitle>
                </div>

                <div v-else>
                    <!-- ++ work section -->
                    <v-card
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 mt-4"
                    >
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <v-row no-gutters>
                                        <v-col cols="auto" class="d-flex align-center justify-start">
                                            <h3 class="pl-4">
                                                Section de travail
                                            </h3>
                                        </v-col>
                                        <v-col cols="auto" class="pl-8 d-flex align-center justify-start">
                                            <template v-if="negatifAmountError">
                                                <v-btn-warning
                                                    size="x-small"
                                                    color="red"
                                                    @click="negatifAmountErrorDialog = true"
                                                >
                                                </v-btn-warning>

                                                <oss-dialog
                                                    v-if="negatifAmountErrorDialog"
                                                    v-model="negatifAmountErrorDialog"
                                                    withoutHeader="true"
                                                    @close="negatifAmountErrorDialog = false"
                                                    min-width="60vw"
                                                >
                                                    <v-alert
                                                        border="start"
                                                        border-color="red"
                                                        elevation="0"
                                                        class="py-4 mb-0"
                                                    >
                                                        <h2 class="mb-2 text-error">
                                                            Des écritures négatives ont été détectées. 
                                                        </h2>

                                                        <h3 class="text-error">
                                                            Il vous faut, si possible, les supprimer, sinon, les contre passer et les lettrer.
                                                        </h3>
                                                    </v-alert>
                                                </oss-dialog>
                                            </template>
                                        </v-col>

                                        <v-col cols="auto" class="pl-8 d-flex align-center justify-start">
                                                <template v-if="someCreditNote">
                                                    <v-btn-warning
                                                        size="x-small"
                                                        color="red"
                                                        @click="someCreditNoteDialog = true"
                                                    >
                                                    </v-btn-warning>

                                                    <oss-dialog
                                                        v-if="someCreditNoteDialog"
                                                        v-model="someCreditNoteDialog"
                                                        withoutHeader="true"
                                                        @close="someCreditNoteDialog = false"
                                                        min-width="60vw"
                                                    >
                                                        <v-alert
                                                            border="start"
                                                            border-color="red"
                                                            elevation="0"
                                                            class="py-4 mb-0"
                                                        >
                                                            <h2 class="mb-2 text-error">
                                                                Des avoirs sur immobilisations ont été détectés. 
                                                            </h2>

                                                            <!-- <h3 class="text-error">
                                                                Il vous faut, si possible, les supprimer, sinon, les contre passer et les lettrer.
                                                            </h3> -->
                                                        </v-alert>
                                                    </oss-dialog>
                                                </template>
                                            </v-col>
                                        <v-spacer />
                                    </v-row>
                                </v-card-title>
                            </v-col>

                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6" />
                                    <v-col cols="6" class="align-center pa-0">
                                        <v-btn-icon
                                            :icon="
                                                workSectionExpand
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            data-cy="AuditConnectedAcrDocuments-documents"
                                            @click="workSectionExpand = !workSectionExpand"
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-card-text v-if="workSectionExpand" transition="expand">
                            <v-row class="pt-6">
                                <v-col class="pt-0 px-0">
                                    <!-- ++ switch -->
                                    <v-row
                                        no-gutters
                                        class="pb-4"
                                        style="position: sticky; top: 0; z-index: 1"
                                    >
                                        <v-col cols="auto">
                                            <v-switch
                                                v-model="switchShowDepreciated"
                                                :label="`Immos amorties`"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                            />
                                        </v-col>

                                        <v-spacer />

                                        <v-col cols="auto">
                                            <v-switch
                                                v-model="switchNA"
                                                :label="`Immos N/A`"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                            />
                                        </v-col>

                                        <v-spacer />

                                        <v-col cols="auto">
                                            <v-switch
                                                v-model="switchOnlyNewEntry"
                                                :label="`Entrées N`"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                            />
                                        </v-col>

                                        <v-spacer />

                                        <v-col cols="auto" v-if="hasCutPreviousAlAcr">
                                            <v-switch
                                                v-model="switchOnlyCutPrevious"
                                                :label="$t('audit.switch.onlyCutPrevious')"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                                data-cy="CheckFixedAssetsToDepreciate-switchOnlyCutPrevious"
                                            />
                                        </v-col>

                                        <v-spacer v-if="hasCutPreviousAlAcr" />

                                        <v-col cols="auto">
                                            <v-switch
                                                v-model="switchOutFlowed"
                                                :label="`Immos sorties`"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                            />
                                        </v-col>

                                        <v-spacer />

                                        <v-col cols="auto">
                                            <v-switch
                                                v-model="switchDepreciationTable"
                                                :label="`Détails amos`"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                            />
                                        </v-col>

                                        <v-spacer />

                                        <v-col cols="auto">
                                            <v-switch
                                                v-model="switchOutFlowTable"
                                                :label="`Détails sorties `"
                                                style="text-center"
                                                class="mx-2 mt-0"
                                                :hide-details="true"
                                            />
                                        </v-col>
                                    </v-row>

                                    <!-- ++ card fixed assets accountable accounts -->
                                    <v-card
                                        elevation="0"
                                        style="background-color: white; border-radius: 25px"
                                        class="py-4 px-0"
                                    >
                                        <v-expansion-panels flat v-model="localPanel" multiple>
                                            <v-expansion-panel
                                                v-for="accAccount of invoicesAccountingLinesACRFilter.sortedAccountableAccounts"
                                                :key="accAccount"
                                                :model-value="accAccount"
                                                class="px-0"
                                            >
                                                <v-expansion-panel-title
                                                    data-cy="CheckFixedAssetsToDepreciate - header"
                                                    class="px-4"
                                                >
                                                    <h3
                                                        v-if="
                                                            invoicesAccountingLinesACRFilter.filteredIAL &&
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount] &&
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0] &&
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0]
                                                                .currentAlAcrData &&
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0]
                                                                .currentAlAcrData
                                                                .accountableAccount &&
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0]
                                                                .currentAlAcrData.accountableAccount
                                                                .name &&
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0]
                                                                .currentAlAcrData.accountableAccount
                                                                .description
                                                        "
                                                    >
                                                        {{
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0]
                                                                .currentAlAcrData.accountableAccount
                                                                .name
                                                        }}
                                                        -
                                                        {{
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount][0]
                                                                .currentAlAcrData.accountableAccount
                                                                .description
                                                        }}
                                                    </h3>

                                                    <template v-slot:actions>
                                                        <v-icon> $expand </v-icon>
                                                    </template>
                                                </v-expansion-panel-title>

                                                <!-- ++ expansion fixed assets accountable accounts -->
                                                <v-expansion-panel-text class="px-0">
                                                    <v-data-table
                                                        :headers="switchHeaders"
                                                        :items="
                                                            invoicesAccountingLinesACRFilter
                                                                .filteredIAL[accAccount]
                                                        "
                                                        fixed-header
                                                        :items-per-page="-1"
                                                        density="compact"
                                                        class="table"
                                                        style="border: 1px #ededed solid"
                                                    >
                                                        <template #no-data
                                                            >Aucune immobilisation</template
                                                        >

                                                        <template v-slot:item="props">
                                                            <tr v-if="props.item.currentAlAcrData">
                                                                <!-- ++ 1st columns group: fixed assets -->
                                                                <!-- ** ICON : DOCUMENT VIEW  -->
                                                                <td class="text-left pl-2 py-0">
                                                                    <div
                                                                        class="text-center"
                                                                        v-if="
                                                                            !showAlAcrDocuments(
                                                                                props.item
                                                                                    .currentAlAcrData,
                                                                            )
                                                                        "
                                                                    >
                                                                        <v-tooltip
                                                                            location="bottom"
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    props,
                                                                                }"
                                                                            >
                                                                                <v-icon
                                                                                    icon="$remove_red_eye"
                                                                                    v-bind="props"
                                                                                    color="primary"
                                                                                    size="large"
                                                                                    class="opacity-20"
                                                                                >
                                                                                </v-icon>
                                                                            </template>
                                                                            <span>
                                                                                {{
                                                                                    $t(
                                                                                        "document.common.notAnyDocument",
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                        </v-tooltip>
                                                                    </div>
                                                                    <v-btn-icon
                                                                        icon="$remove_red_eye"
                                                                        color="primary"
                                                                        v-if="
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .documentId &&
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .objectType &&
                                                                            showAlAcrDocuments(
                                                                                props.item
                                                                                    .currentAlAcrData,
                                                                            )
                                                                        "
                                                                        @click="
                                                                            openDocumentAlAcr(
                                                                                props.item
                                                                                    .currentAlAcrData,
                                                                            )
                                                                        "
                                                                        size="large"
                                                                    />
                                                                </td>

                                                                <!-- ** fixedAssetWording -->
                                                                <td
                                                                    class="text-left pl-2 py-0"
                                                                    v-if="
                                                                        props.item.currentAlAcrData
                                                                            .fixedAssetWording
                                                                    "
                                                                >
                                                                    {{
                                                                        props.item.currentAlAcrData
                                                                            .fixedAssetWording
                                                                    }}
                                                                </td>

                                                                <td
                                                                    class="text-left pl-2 py-0"
                                                                    v-else-if="
                                                                        props.item.currentAlAcrData
                                                                            .wording
                                                                    "
                                                                >
                                                                    {{
                                                                        props.item.currentAlAcrData
                                                                            .wording
                                                                    }}
                                                                </td>

                                                                <td v-else class="text-left px-2">
                                                                    -
                                                                </td>

                                                                <!-- ** purchase date -->
                                                                <td
                                                                    class="text-left pl-2 py-0"
                                                                    v-if="
                                                                        props.item.currentAlAcrData
                                                                            .date
                                                                    "
                                                                >
                                                                    {{
                                                                        formatDate(
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .date,
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td v-else />

                                                                <!-- ** linearSpreadStartDate - date de mise en service -->
                                                                <td
                                                                    class="text-left pl-2 py-0"
                                                                    v-if="
                                                                        props.item.currentAlAcrData
                                                                            .linearSpreadStartDate
                                                                    "
                                                                >
                                                                    {{
                                                                        formatDate(
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .linearSpreadStartDate,
                                                                        )
                                                                    }}
                                                                </td>

                                                                <td v-else />

                                                                <!-- ** amountSigned HT -->
                                                                <td
                                                                    :class="
                                                                        actionColorNegativeAmount(
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .amountSigned,
                                                                        )
                                                                    "
                                                                >
                                                                    <v-tooltip
                                                                        v-if="
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .amountSigned < 0 || props.item.currentAlAcrData.creditNote
                                                                        "
                                                                        location="bottom"
                                                                    >
                                                                        <template v-slot:activator="{props: tooltipProps}">
                                                                            <span v-bind="tooltipProps">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .amountSigned,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </span>
                                                                        </template>

                                                                        <h3 v-if="props.item.currentAlAcrData.creditNote" 
                                                                            class="mb-0"
                                                                        >
                                                                            Attention : Avoir sur immobilisation
                                                                        </h3>

                                                                        <h3 v-else class="mb-0">
                                                                            Attention : montant au crédit
                                                                        </h3>

                                                                        <p v-if="!props.item.currentAlAcrData.creditNote" class="mb-0">
                                                                            Afin de ne pas
                                                                            initialiser des
                                                                            immobilisations
                                                                            négatives
                                                                        </p>

                                                                        <p v-if="!props.item.currentAlAcrData.creditNote" class="mb-0">
                                                                            Il est conseillé de
                                                                            retourner dans le
                                                                            grand-livre, passer une
                                                                            OD de régul, afin de
                                                                            créer une immobilisation
                                                                            avec le montant réduit
                                                                        </p>
                                                                        <p v-if="!props.item.currentAlAcrData.creditNote" class="mb-0">
                                                                            N'oubliez pas de lettrer
                                                                            le débit brut et le crédit
                                                                        </p>
                                                                    </v-tooltip>

                                                                    <div v-else>
                                                                        {{
                                                                        newCommonFormatCurrency(
                                                                            props.item
                                                                                .currentAlAcrData
                                                                                .amountSigned,
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                    </div>
                                                                </td>

                                                                <!-- ** VAT -->
                                                                <!-- ** not if credit note -->
                                                                <td
                                                                    class="text-right"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                    "
                                                                    v-if="
                                                                        props.item.currentAlAcrData
                                                                            .amountSigned &&
                                                                        props.item.currentAlAcrData
                                                                            .alVatAmountSigned > 0
                                                                    "
                                                                >
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            Math.abs(
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .alVatAmountSigned,
                                                                            ),
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </td>
                                                                <td
                                                                    v-else
                                                                    class="text-right"
                                                                    style="
                                                                        border-right: 1px #ededed
                                                                            solid;
                                                                    "
                                                                >
                                                                    -
                                                                </td>

                                                                <!-- ++ 2nd columns group: depreciations -->

                                                                <!-- ++ type N/A -->
                                                                <template
                                                                    v-if="
                                                                        props.item.currentAlAcrData
                                                                            .type &&
                                                                        props.item.currentAlAcrData
                                                                            .type === 'N/A'
                                                                    "
                                                                >
                                                                    <!-- ** ICON : generate table  -->
                                                                    <td class="text-center">N/A</td>

                                                                    <template
                                                                        v-if="
                                                                            switchDepreciationTable
                                                                        "
                                                                    >
                                                                        <!-- ** type -->
                                                                        <td class="text-left">-</td>

                                                                        <!-- ** selectedYearDuration -->
                                                                        <td class="text-left">-</td>

                                                                        <!-- ** start date -->
                                                                        <td class="text-center">
                                                                            -
                                                                        </td>

                                                                        <!-- ** end date -->
                                                                        <td class="text-center">
                                                                            -
                                                                        </td>

                                                                        <!-- ** previous depreciations  -->
                                                                        <td class="text-right">
                                                                            -
                                                                        </td>

                                                                        <!-- ** N L depreciation  -->
                                                                        <td class="text-right">
                                                                            -
                                                                        </td>

                                                                        <!-- ** N Derog depreciation  -->
                                                                        <td class="text-right">
                                                                            -
                                                                        </td>

                                                                        <!-- ** accumulated depreciations  -->
                                                                        <td class="text-right">
                                                                            -
                                                                        </td>

                                                                        <!-- ** netBookValueEnd  -->
                                                                        <td class="text-right">
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    getPeriodLine(
                                                                                        props.item
                                                                                            .currentAlAcrData,
                                                                                    )
                                                                                        .netBookValueEnd,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>
                                                                    </template>
                                                                </template>

                                                                <!-- ++ no N/A -->
                                                                <template v-else>
                                                                    <!-- ++ no depreciationTable -->
                                                                    <template
                                                                        v-if="
                                                                            !props.item
                                                                                .currentAlAcrData
                                                                                .depreciationTable ||
                                                                            !props.item
                                                                                .currentAlAcrData
                                                                                .depreciationTable
                                                                                .length
                                                                        "
                                                                    >
                                                                        <!-- ** fixed asset's ACR is not created -->
                                                                        <!-- ** fixed asset date is in closed period -->
                                                                        <!-- ** intangible or financial fixed asset -->
                                                                        <!-- ** cut previous already done -->
                                                                        <template
                                                                            v-if="
                                                                                showOnlyNAGenerateTableBtn(
                                                                                    props.item
                                                                                        .currentAlAcrData,
                                                                                )
                                                                            "
                                                                        >
                                                                            <td class="text-center">
                                                                                <v-tooltip
                                                                                    location="bottom"
                                                                                >
                                                                                    <template
                                                                                        v-slot:activator="{
                                                                                            props,
                                                                                        }"
                                                                                    >
                                                                                        <div
                                                                                            v-bind="
                                                                                                props
                                                                                            "
                                                                                            class="d-inline-block"
                                                                                        >
                                                                                            <v-btn-icon
                                                                                                icon="$spellcheck"
                                                                                                color="red"
                                                                                                size="large"
                                                                                                @click="
                                                                                                    onlyNaType = true;
                                                                                                    step =
                                                                                                        'setTypeNaOnClosedPeriod';
                                                                                                    openDialog(
                                                                                                        props.item,
                                                                                                    );
                                                                                                "
                                                                                            />
                                                                                        </div>
                                                                                    </template>
                                                                                    <span>
                                                                                        <!-- <v-row>
                                                                                            <v-col> -->
                                                                                        <p>
                                                                                            La
                                                                                            "Reprise
                                                                                            d'immobilisations
                                                                                            et
                                                                                            amortissements
                                                                                            sur
                                                                                            exercices
                                                                                            antérieurs"
                                                                                            a déjà
                                                                                            été
                                                                                            effectuée,
                                                                                        </p>
                                                                                        <!-- </v-col>
                                                                                        </v-row>
                                                                                        <v-row>
                                                                                            <v-col> -->
                                                                                        <p>
                                                                                            mais
                                                                                            cette
                                                                                            immobilisation,
                                                                                            incorporelle
                                                                                            où
                                                                                            financière,
                                                                                            placée
                                                                                            dans une
                                                                                            période
                                                                                            clôturée,
                                                                                            n'a pas
                                                                                            été
                                                                                            initialisée.
                                                                                        </p>
                                                                                        <!-- </v-col>
                                                                                        </v-row>
                                                                                        <v-row>
                                                                                            <v-col> -->
                                                                                        <p>
                                                                                            Les
                                                                                            seules
                                                                                            actions
                                                                                            requises
                                                                                            et
                                                                                            permises,
                                                                                            afin de
                                                                                            ne pas
                                                                                            modifier
                                                                                            les
                                                                                            balances
                                                                                            et les
                                                                                            grand-livres
                                                                                            des
                                                                                            périodes
                                                                                            clôturées,
                                                                                            sont
                                                                                        </p>
                                                                                        <p>
                                                                                            - la
                                                                                            définir
                                                                                            en tant
                                                                                            que non
                                                                                            amortissable
                                                                                            (N/A)
                                                                                        </p>
                                                                                        <p>
                                                                                            -
                                                                                            changer
                                                                                            le
                                                                                            libellé
                                                                                            (si pas
                                                                                            généré
                                                                                            par la
                                                                                            reprise)
                                                                                        </p>
                                                                                        <p>
                                                                                            -
                                                                                            éventuellement,
                                                                                            modifier
                                                                                            le
                                                                                            montant
                                                                                            de la
                                                                                            TVA
                                                                                            afférente
                                                                                        </p>
                                                                                        <!-- </v-col>
                                                                                        </v-row> -->
                                                                                    </span>
                                                                                </v-tooltip>
                                                                            </td>
                                                                        </template>

                                                                        <!-- ++ no depreciationTable -->
                                                                        <!-- ** type other then N/A -->

                                                                        <!-- ** with outflow date -->
                                                                        <!-- ** or in closed period -->
                                                                        <!-- ** ou wording starting with "Reprise" (automatically generated by cutPrevious) -->
                                                                        <template
                                                                            v-else-if="
                                                                                !showGenerateTableBtn(
                                                                                    props.item
                                                                                        .currentAlAcrData,
                                                                                )
                                                                            "
                                                                        >
                                                                            <td class="text-center">
                                                                                <v-tooltip
                                                                                    location="bottom"
                                                                                >
                                                                                    <template
                                                                                        v-slot:activator="{
                                                                                            props,
                                                                                        }"
                                                                                    >
                                                                                        <div
                                                                                            v-bind="
                                                                                                props
                                                                                            "
                                                                                            class="d-inline-block"
                                                                                        >
                                                                                            <v-btn-icon
                                                                                                icon="$spellcheck"
                                                                                                size="large"
                                                                                                disabled
                                                                                            />
                                                                                        </div>
                                                                                    </template>
                                                                                    <span
                                                                                        >Tableau à
                                                                                        générer dans
                                                                                        le contrôle
                                                                                        dédié
                                                                                        "Reprise
                                                                                        d'immobilisations
                                                                                        antérieures"</span
                                                                                    >
                                                                                </v-tooltip>
                                                                            </td>
                                                                        </template>

                                                                        <!-- ++ no depreciationTable -->
                                                                        <!-- ** ** type other then N/A -->

                                                                        <!-- ** without outflow date -->
                                                                        <!-- ** not in closed period -->
                                                                        <!-- ** wording not starting with "Reprise" (automatically generated by cutPrevious) -->
                                                                        <template
                                                                            v-else-if="
                                                                                showGenerateTableBtn(
                                                                                    props.item
                                                                                        .currentAlAcrData,
                                                                                )
                                                                            "
                                                                        >
                                                                            <td class="text-center">
                                                                                <v-btn-icon
                                                                                    icon="$spellcheck"
                                                                                    size="large"
                                                                                    :color="
                                                                                        actionColor(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                    "
                                                                                    @click="
                                                                                        generateDepreciation = true;
                                                                                        step =
                                                                                            'generateDepreciationStep';
                                                                                        openDialog(
                                                                                            props.item,
                                                                                        );
                                                                                    "
                                                                                />
                                                                            </td>
                                                                        </template>
                                                                    </template>

                                                                    <!-- ++ with depreciationTable -->
                                                                    <template v-else>
                                                                        <td class="text-center">
                                                                            <v-btn-icon
                                                                                icon="$remove_red_eye"
                                                                                color="primary"
                                                                                @click="
                                                                                    step =
                                                                                        'tableStep';
                                                                                    openOnlyShowDialog(
                                                                                        props.item,
                                                                                    );
                                                                                "
                                                                                size="large"
                                                                            />
                                                                        </td>
                                                                    </template>

                                                                    <!-- ++ details depreciation columns -->
                                                                    <template
                                                                        v-if="
                                                                            switchDepreciationTable
                                                                        "
                                                                    >
                                                                        <!-- ++ with depreciationTable -->
                                                                        <template
                                                                            v-if="
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .depreciationTable &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .depreciationTable
                                                                                    .length
                                                                            "
                                                                        >
                                                                            <!-- ** type -->
                                                                            <td
                                                                                class="text-left"
                                                                                v-if="
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .linearDepreciation
                                                                                "
                                                                                :color="
                                                                                    actionColor(
                                                                                        props.item
                                                                                            .currentAlAcrData,
                                                                                    )
                                                                                "
                                                                            >
                                                                                L
                                                                            </td>
                                                                            <td
                                                                                class="text-left"
                                                                                v-else
                                                                                :color="
                                                                                    actionColor(
                                                                                        props.item
                                                                                            .currentAlAcrData,
                                                                                    )
                                                                                "
                                                                            >
                                                                                D
                                                                            </td>

                                                                            <!-- ** selectedYearDuration -->
                                                                            <td
                                                                                v-if="
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .selectedYearDuration
                                                                                "
                                                                                class="text-left"
                                                                                :color="
                                                                                    actionColor(
                                                                                        props.item
                                                                                            .currentAlAcrData,
                                                                                    )
                                                                                "
                                                                            >
                                                                                {{
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .selectedYearDuration
                                                                                }}
                                                                            </td>
                                                                            <td
                                                                                v-else
                                                                                class="text-left"
                                                                            >
                                                                                -
                                                                            </td>

                                                                            <!-- ** start date -->
                                                                            <td
                                                                                class="text-center pl-2 py-0"
                                                                                v-if="
                                                                                    !props.item
                                                                                        .currentAlAcrData
                                                                                        .linearDepreciation &&
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .decliningSpreadStartDate
                                                                                "
                                                                            >
                                                                                {{
                                                                                    formatDate(
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .decliningSpreadStartDate,
                                                                                    )
                                                                                }}
                                                                            </td>
                                                                            <td
                                                                                class="text-center pl-2 py-0"
                                                                                v-else-if="
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .linearSpreadStartDate
                                                                                "
                                                                            >
                                                                                {{
                                                                                    formatDate(
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .linearSpreadStartDate,
                                                                                    )
                                                                                }}
                                                                            </td>

                                                                            <td v-else />

                                                                            <!-- ** end date -->
                                                                            <td
                                                                                class="text-center pl-2 py-0"
                                                                                v-if="
                                                                                    !props.item
                                                                                        .currentAlAcrData
                                                                                        .linearDepreciation &&
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .decliningSpreadEndDate
                                                                                "
                                                                            >
                                                                                {{
                                                                                    formatDate(
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .decliningSpreadEndDate,
                                                                                    )
                                                                                }}
                                                                            </td>

                                                                            <td
                                                                                class="text-center pl-2 py-0"
                                                                                v-else-if="
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .linearSpreadEndDate
                                                                                "
                                                                            >
                                                                                {{
                                                                                    formatDate(
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .linearSpreadEndDate,
                                                                                    )
                                                                                }}
                                                                            </td>
                                                                            <td v-else />

                                                                            <!-- ** previous depreciations  -->
                                                                            <td class="text-right">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        getPeriodLine(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                            .previousDepreciations,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </td>

                                                                            <!-- ** N L depreciation  -->
                                                                            <td class="text-right">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        getPeriodLine(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                            .currentLinearDepreciation,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </td>

                                                                            <!-- ** N Derog depreciation  -->
                                                                            <td class="text-right">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        getPeriodLine(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                            .currentDerogationDepreciation,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </td>

                                                                            <!-- ** accumulated depreciations  -->
                                                                            <td class="text-right">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        getPeriodLine(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                            .accumulatedDepreciations,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </td>

                                                                            <!-- ** netBookValueEnd  -->
                                                                            <td class="text-right">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        getPeriodLine(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                            .netBookValueEnd,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </td>
                                                                        </template>

                                                                        <!-- ++ no depreciationTable -->
                                                                        <template v-else>
                                                                            <!-- ** type -->
                                                                            <td class="text-left">
                                                                                -
                                                                            </td>

                                                                            <!-- ** selectedYearDuration -->
                                                                            <td class="text-left">
                                                                                -
                                                                            </td>

                                                                            <!-- ** start date -->
                                                                            <td class="text-center">
                                                                                -
                                                                            </td>

                                                                            <!-- ** end date -->
                                                                            <td class="text-center">
                                                                                -
                                                                            </td>

                                                                            <!-- ** previous depreciations  -->
                                                                            <td class="text-right">
                                                                                -
                                                                            </td>

                                                                            <!-- ** N L depreciation  -->
                                                                            <td class="text-right">
                                                                                -
                                                                            </td>

                                                                            <!-- ** N Derog depreciation  -->
                                                                            <td class="text-right">
                                                                                -
                                                                            </td>

                                                                            <!-- ** accumulated depreciations  -->
                                                                            <td class="text-right">
                                                                                -
                                                                            </td>

                                                                            <!-- ** netBookValueEnd  -->
                                                                            <td class="text-right">
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        getPeriodLine(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                            .netBookValueEnd,
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </td>
                                                                        </template>
                                                                    </template>
                                                                </template>

                                                                <!-- ++ 3rd columns group: outflow -->

                                                                <!-- ** no outflowDate -->
                                                                <!-- ** with depreciationTable || type N/A -->
                                                                <template
                                                                    v-if="
                                                                        !props.item.currentAlAcrData
                                                                            .outflowDate
                                                                    "
                                                                >
                                                                    <td
                                                                        class="text-center"
                                                                        style="
                                                                            border-left: 1px #ededed
                                                                                solid;
                                                                        "
                                                                    >
                                                                        <v-btn-icon
                                                                            icon="$spellcheck"
                                                                            size="large"
                                                                            color="primary"
                                                                            :disabled="
                                                                                !showOutFlowBtn(
                                                                                    props.item
                                                                                        .currentAlAcrData,
                                                                                )
                                                                            "
                                                                            @click="
                                                                                generateDepreciation = false;
                                                                                step =
                                                                                    'outflowStep';
                                                                                openDialog(
                                                                                    props.item,
                                                                                );
                                                                            "
                                                                        />
                                                                    </td>

                                                                    <!-- ** optionnals outflow columns -->
                                                                    <template
                                                                        v-if="switchOutFlowTable"
                                                                    >
                                                                        <td class="text-right">
                                                                            -
                                                                        </td>

                                                                        <td class="text-right">
                                                                            -
                                                                        </td>

                                                                        <td class="text-right">
                                                                            -
                                                                        </td>
                                                                    </template>
                                                                </template>

                                                                <!-- ** with outflow date -->
                                                                <template v-else>
                                                                    <td
                                                                        class="text-center"
                                                                        style="
                                                                            border-left: 1px #ededed
                                                                                solid;
                                                                        "
                                                                    >
                                                                        {{
                                                                            formatDate(
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate,
                                                                            )
                                                                        }}
                                                                    </td>

                                                                    <!-- ** optionnals outflow columns -->
                                                                    <template
                                                                        v-if="switchOutFlowTable"
                                                                    >
                                                                        <!-- ** VNC L - outflowLinearNetBookValue  -->
                                                                        <td
                                                                            v-if="
                                                                                props.item
                                                                                    .currentAlAcrData &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate <=
                                                                                    formatDatePicker(
                                                                                        accountingPeriod.end,
                                                                                    )
                                                                            "
                                                                            class="text-right"
                                                                        >
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .outflowLinearNetBookValue,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>

                                                                        <td
                                                                            v-else-if="
                                                                                props.item
                                                                                    .currentAlAcrData &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate
                                                                            "
                                                                            class="text-right"
                                                                        >
                                                                            à venir
                                                                        </td>

                                                                        <td
                                                                            v-else
                                                                            class="text-right"
                                                                        >
                                                                            -
                                                                        </td>

                                                                        <!-- ** sellAmount  -->
                                                                        <td
                                                                            v-if="
                                                                                props.item
                                                                                    .currentAlAcrData &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate <=
                                                                                    formatDatePicker(
                                                                                        accountingPeriod.end,
                                                                                    )
                                                                            "
                                                                            class="text-right"
                                                                        >
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .sellAmount,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>

                                                                        <td
                                                                            v-else-if="
                                                                                props.item
                                                                                    .currentAlAcrData &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate
                                                                            "
                                                                            class="text-right"
                                                                        >
                                                                            à venir
                                                                        </td>

                                                                        <td
                                                                            v-else
                                                                            class="text-right"
                                                                        >
                                                                            -
                                                                        </td>

                                                                        <!-- ** more or less value  -->
                                                                        <td
                                                                            v-if="
                                                                                props.item
                                                                                    .currentAlAcrData &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate <=
                                                                                    formatDatePicker(
                                                                                        accountingPeriod.end,
                                                                                    )
                                                                            "
                                                                            class="text-right"
                                                                        >
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    -props.item
                                                                                        .currentAlAcrData
                                                                                        .moreOrLessValue ||
                                                                                        0,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </td>
                                                                        <td
                                                                            v-else-if="
                                                                                props.item
                                                                                    .currentAlAcrData &&
                                                                                props.item
                                                                                    .currentAlAcrData
                                                                                    .outflowDate
                                                                            "
                                                                            class="text-right"
                                                                        >
                                                                            à venir
                                                                        </td>

                                                                        <td
                                                                            v-else
                                                                            class="text-right"
                                                                        >
                                                                            -
                                                                        </td>
                                                                    </template>
                                                                </template>

                                                                <!-- ++ change or delete ACR -->
                                                                <td
                                                                    class="text-center"
                                                                    style="
                                                                        border-left: 1px #ededed
                                                                            solid;
                                                                    "
                                                                >
                                                                    <v-menu>
                                                                        <!-- // icon more_vert -->
                                                                        <template
                                                                            v-slot:activator="{
                                                                                props,
                                                                            }"
                                                                        >
                                                                            <v-btn-icon
                                                                                icon="$dots_vertical"
                                                                                v-bind="props"
                                                                                class="mx-1"
                                                                                size="large"
                                                                                color="primary"
                                                                            />
                                                                        </template>

                                                                        <!-- ++ ACTIONS POSSIBLES : delete ou create -->
                                                                        <v-list nav width="500px">
                                                                            <!-- ++ with acrId -->
                                                                            <template
                                                                                v-if="
                                                                                    props.item
                                                                                        .currentAlAcrData
                                                                                        .acrId
                                                                                "
                                                                            >
                                                                                <!-- ++ with outflow date -->
                                                                                <template
                                                                                    v-if="
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .outflowDate
                                                                                    "
                                                                                >
                                                                                    <!-- **  dans période ouverte - deletePeriodNOutFlow-->
                                                                                    <template
                                                                                        v-if="
                                                                                            !inClosedAccountingPeriod(
                                                                                                props
                                                                                                    .item
                                                                                                    .currentAlAcrData
                                                                                                    .outflowDate,
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <v-list-item
                                                                                            @click="
                                                                                                deletePeriodNOutFlow(
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData,
                                                                                                )
                                                                                            "
                                                                                            :color="
                                                                                                actionColor(
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData,
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <v-list-item-title
                                                                                                width="450px"
                                                                                            >
                                                                                                Supprimer
                                                                                                la
                                                                                                sortie
                                                                                                d'immobilisation
                                                                                            </v-list-item-title>

                                                                                            <template
                                                                                                v-slot:append
                                                                                            >
                                                                                                <v-icon
                                                                                                    :color="
                                                                                                        actionColor(
                                                                                                            props
                                                                                                                .item
                                                                                                                .currentAlAcrData,
                                                                                                        )
                                                                                                    "
                                                                                                    size="large"
                                                                                                    icon="$oss-trash"
                                                                                                />
                                                                                            </template>
                                                                                        </v-list-item>
                                                                                    </template>

                                                                                    <!-- ** in closed period - disabled-->
                                                                                    <div
                                                                                        v-else
                                                                                        class="d-flex align-center"
                                                                                    >
                                                                                        <v-tooltip
                                                                                            location="bottom"
                                                                                        >
                                                                                            <template
                                                                                                v-slot:activator="{
                                                                                                    props,
                                                                                                }"
                                                                                            >
                                                                                                <div
                                                                                                    v-bind="
                                                                                                        props
                                                                                                    "
                                                                                                >
                                                                                                    <v-list-item
                                                                                                        disabled
                                                                                                    >
                                                                                                        <v-list-item-title
                                                                                                            width="450px"
                                                                                                        >
                                                                                                            Supprimer
                                                                                                            la
                                                                                                            sortie
                                                                                                            d'immobilisation
                                                                                                        </v-list-item-title>
                                                                                                        <template
                                                                                                            v-slot:append
                                                                                                        >
                                                                                                            <v-icon
                                                                                                                :color="
                                                                                                                    actionColor(
                                                                                                                        props
                                                                                                                            .item
                                                                                                                            .currentAlAcrData,
                                                                                                                    )
                                                                                                                "
                                                                                                                size="large"
                                                                                                                icon="$oss-trash"
                                                                                                            />
                                                                                                        </template>
                                                                                                    </v-list-item>
                                                                                                </div>
                                                                                            </template>
                                                                                            <span>
                                                                                                La
                                                                                                sortie
                                                                                                d'immobilisation
                                                                                                est
                                                                                                dans
                                                                                                un
                                                                                                exercice
                                                                                                clôturé
                                                                                            </span>
                                                                                        </v-tooltip>
                                                                                    </div>
                                                                                </template>

                                                                                <!-- ++ without outflow date -->
                                                                                <template
                                                                                    v-if="
                                                                                        !props.item
                                                                                            .currentAlAcrData
                                                                                            .outflowDate &&
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .acrId &&
                                                                                        props.item
                                                                                            .currentAlAcrData
                                                                                            .linearSpreadStartDate
                                                                                    "
                                                                                >
                                                                                    <!-- ++ linear spread start date in open period -->

                                                                                    <!-- ++ isResultOf cutPrevious - disabled -->
                                                                                    <div
                                                                                        v-if="
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData
                                                                                                .documentIsResultOf
                                                                                        "
                                                                                    >
                                                                                        <v-tooltip
                                                                                            location="bottom"
                                                                                        >
                                                                                            <template
                                                                                                v-slot:activator="{
                                                                                                    props,
                                                                                                }"
                                                                                            >
                                                                                                <div
                                                                                                    v-bind="
                                                                                                        props
                                                                                                    "
                                                                                                >
                                                                                                    <v-list-item
                                                                                                        disabled
                                                                                                    >
                                                                                                        <v-list-item-title
                                                                                                            width="450px"
                                                                                                            data-cy="CheckFixedAssetsToDepreciate-delete"
                                                                                                        >
                                                                                                            Supprimer
                                                                                                            le
                                                                                                            tableau
                                                                                                            d'amortissement
                                                                                                            ou
                                                                                                            le
                                                                                                            type
                                                                                                        </v-list-item-title>

                                                                                                        <template
                                                                                                            v-slot:append
                                                                                                        >
                                                                                                            <v-icon
                                                                                                                icon="$oss-trash"
                                                                                                            />
                                                                                                        </template>
                                                                                                    </v-list-item>
                                                                                                </div>
                                                                                            </template>

                                                                                            <span
                                                                                                v-if="
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .documentIsResultOf &&
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .documentIsResultOf
                                                                                                        .id
                                                                                                "
                                                                                            >
                                                                                                <p>
                                                                                                    Ce
                                                                                                    document
                                                                                                    a
                                                                                                    été
                                                                                                    généré
                                                                                                    par
                                                                                                    la
                                                                                                    reprise
                                                                                                    d'immobilisation
                                                                                                </p>

                                                                                                <p>
                                                                                                    La
                                                                                                    mise
                                                                                                    en
                                                                                                    service
                                                                                                    et
                                                                                                    le
                                                                                                    début
                                                                                                    des
                                                                                                    amortissements
                                                                                                    sont
                                                                                                    dans
                                                                                                    un
                                                                                                    exercice
                                                                                                    clôturé
                                                                                                </p>
                                                                                            </span>
                                                                                        </v-tooltip>
                                                                                    </div>

                                                                                    <!-- ++ deleteACR - linear spread start date in open period -->
                                                                                    <div
                                                                                        v-else-if="
                                                                                            !inClosedAccountingPeriod(
                                                                                                props
                                                                                                    .item
                                                                                                    .currentAlAcrData
                                                                                                    .linearSpreadStartDate,
                                                                                            )
                                                                                        "
                                                                                    >
                                                                                        <v-list-item
                                                                                            @click="
                                                                                                deleteAuditCheckResult(
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .acrId,
                                                                                                )
                                                                                            "
                                                                                            :color="
                                                                                                actionColor(
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData,
                                                                                                )
                                                                                            "
                                                                                        >
                                                                                            <v-list-item-title
                                                                                                width="450px"
                                                                                                data-cy="CheckFixedAssetsToDepreciate-delete"
                                                                                            >
                                                                                                Supprimer
                                                                                                le
                                                                                                tableau
                                                                                                d'amortissement
                                                                                                ou
                                                                                                le
                                                                                                type
                                                                                            </v-list-item-title>

                                                                                            <template
                                                                                                v-slot:append
                                                                                            >
                                                                                                <v-icon
                                                                                                    icon="$oss-trash"
                                                                                                />
                                                                                            </template>
                                                                                        </v-list-item>
                                                                                    </div>

                                                                                    <!-- // modification - en attente de développement : -->
                                                                                    <!-- // Marie-France voudrait pouvoir modifier le taux d'amortissement en cours  -->
                                                                                    <!-- <v-list-item
                                                                                        v-else-if="showModifyTypeNAAndGenerateTableBtn(props.item.currentAlAcrData)"
                                                                                        @click="openDialog(props.item)"
                                                                                    >
                                                                                        <v-list-item-title width="450px">
                                                                                            Modifier le type et générer le tableau d'amortissement
                                                                                        </v-list-item-title>

                                                                                        <template v-slot:append>
                                                                                            <v-icon icon="$spellcheck" />
                                                                                        </template>
                                                                                    </v-list-item> -->

                                                                                    <!-- ++ linear spread start date in closed period > disabled -->
                                                                                    <div
                                                                                        v-else
                                                                                        class="d-flex align-center"
                                                                                    >
                                                                                        <v-tooltip
                                                                                            location="bottom"
                                                                                        >
                                                                                            <template
                                                                                                v-slot:activator="{
                                                                                                    props,
                                                                                                }"
                                                                                            >
                                                                                                <div
                                                                                                    v-bind="
                                                                                                        props
                                                                                                    "
                                                                                                >
                                                                                                    <v-list-item
                                                                                                        disabled
                                                                                                    >
                                                                                                        <v-list-item-title
                                                                                                            width="450px"
                                                                                                        >
                                                                                                            Supprimer
                                                                                                            le
                                                                                                            tableau
                                                                                                            d'amortissement
                                                                                                            et/ou
                                                                                                            la
                                                                                                            sortie
                                                                                                            d'immobilisation
                                                                                                        </v-list-item-title>

                                                                                                        <template
                                                                                                            v-slot:append
                                                                                                        >
                                                                                                            <v-icon
                                                                                                                :color="
                                                                                                                    actionColor(
                                                                                                                        props
                                                                                                                            .item
                                                                                                                            .currentAlAcrData,
                                                                                                                    )
                                                                                                                "
                                                                                                                size="large"
                                                                                                                icon="$oss-trash"
                                                                                                            />
                                                                                                        </template>
                                                                                                    </v-list-item>
                                                                                                </div>
                                                                                            </template>

                                                                                            <!-- ** depreciationTable -->
                                                                                            <template
                                                                                                v-if="
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .depreciationTable &&
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .depreciationTable
                                                                                                        .length
                                                                                                "
                                                                                            >
                                                                                                <span
                                                                                                    v-if="
                                                                                                        props
                                                                                                            .item
                                                                                                            .currentAlAcrData
                                                                                                            .documentIsResultOf &&
                                                                                                        props
                                                                                                            .item
                                                                                                            .currentAlAcrData
                                                                                                            .documentIsResultOf
                                                                                                            .id
                                                                                                    "
                                                                                                >
                                                                                                    Ce
                                                                                                    document
                                                                                                    a
                                                                                                    été
                                                                                                    généré
                                                                                                    par
                                                                                                    la
                                                                                                    reprise
                                                                                                    d'immobilisation
                                                                                                    et
                                                                                                    la
                                                                                                    mise
                                                                                                    en
                                                                                                    service
                                                                                                    et
                                                                                                    le
                                                                                                    début
                                                                                                    des
                                                                                                    amortissements
                                                                                                    sont
                                                                                                    dans
                                                                                                    un
                                                                                                    exercice
                                                                                                    clôturé
                                                                                                </span>

                                                                                                <span
                                                                                                    v-else
                                                                                                >
                                                                                                    La
                                                                                                    mise
                                                                                                    en
                                                                                                    service
                                                                                                    et
                                                                                                    le
                                                                                                    début
                                                                                                    des
                                                                                                    amortissements
                                                                                                    sont
                                                                                                    dans
                                                                                                    un
                                                                                                    exercice
                                                                                                    clôturé
                                                                                                </span>
                                                                                            </template>

                                                                                            <span
                                                                                                v-else
                                                                                            >
                                                                                                Cas
                                                                                                pas
                                                                                                traité
                                                                                                :
                                                                                                merci
                                                                                                de
                                                                                                remonter
                                                                                                l'information
                                                                                                au
                                                                                                support
                                                                                            </span>
                                                                                        </v-tooltip>
                                                                                    </div>
                                                                                </template>

                                                                                <!-- v-else part acrId present -->
                                                                                <v-list-item
                                                                                    @click="
                                                                                        uploadAcrDocument(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <v-list-item-title
                                                                                        width="450px"
                                                                                        data-cy="CheckFixedAssetsToDepreciate-alAcr-document"
                                                                                    >
                                                                                        {{
                                                                                            $t(
                                                                                                "document.common.linkADocument",
                                                                                                props
                                                                                                    .item
                                                                                                    .currentAlAcrData
                                                                                                    .documents
                                                                                                    ?.length ===
                                                                                                    0
                                                                                                    ? 1
                                                                                                    : 2,
                                                                                            )
                                                                                        }}
                                                                                    </v-list-item-title>

                                                                                    <template
                                                                                        v-slot:append
                                                                                    >
                                                                                        <v-icon
                                                                                            icon="$oss-upload"
                                                                                        />
                                                                                    </template>
                                                                                </v-list-item>
                                                                            </template>

                                                                            <!-- ++ without ACR -->
                                                                            <template v-else>
                                                                                <!-- ++ linear spread start date in open period -->
                                                                                <!-- ** possible to generate L / D / N/A types-->
                                                                                <v-list-item
                                                                                    v-if="
                                                                                        (props.item
                                                                                            .currentAlAcrData
                                                                                            .linearSpreadStartDate ||
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData
                                                                                                .date) &&
                                                                                        !inClosedAccountingPeriod(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData
                                                                                                .linearSpreadStartDate ||
                                                                                                props
                                                                                                    .item
                                                                                                    .currentAlAcrData
                                                                                                    .date,
                                                                                        )
                                                                                    "
                                                                                    @click="
                                                                                        generateDepreciation = true;
                                                                                        step =
                                                                                            'generateDepreciationStep';
                                                                                        openDialog(
                                                                                            props.item,
                                                                                        );
                                                                                    "
                                                                                    :color="
                                                                                        actionColor(
                                                                                            props
                                                                                                .item
                                                                                                .currentAlAcrData,
                                                                                        )
                                                                                    "
                                                                                >
                                                                                    <v-list-item-title
                                                                                        width="450px"
                                                                                    >
                                                                                        Générer le
                                                                                        tableau
                                                                                        d'amortissement
                                                                                        ou définir
                                                                                        le type
                                                                                    </v-list-item-title>
                                                                                    <template
                                                                                        v-slot:append
                                                                                    >
                                                                                        <v-icon
                                                                                            icon="$spellcheck"
                                                                                            size="large"
                                                                                        />
                                                                                    </template>
                                                                                </v-list-item>

                                                                                <!-- ++ linear spread start date in closed period -->
                                                                                <template v-else>
                                                                                    <!-- ++ 20 or 27 accountable accounts -->
                                                                                    <!-- ** only generate N/A type-->
                                                                                    <v-list-item
                                                                                        v-if="
                                                                                            showNABtn(
                                                                                                props
                                                                                                    .item
                                                                                                    .currentAlAcrData,
                                                                                            )
                                                                                        "
                                                                                        @click="
                                                                                            step =
                                                                                                'generateDepreciationStep';
                                                                                            hideDurationAndStartDate = true;
                                                                                            openDialog(
                                                                                                props.item,
                                                                                            );
                                                                                        "
                                                                                    >
                                                                                        <v-list-item-title
                                                                                            width="450px"
                                                                                        >
                                                                                            Définir
                                                                                            le type
                                                                                            à N/A
                                                                                        </v-list-item-title>

                                                                                        <template
                                                                                            v-slot:append
                                                                                        >
                                                                                            <v-icon
                                                                                                icon="$spellcheck"
                                                                                                size="large"
                                                                                            />
                                                                                        </template>
                                                                                    </v-list-item>

                                                                                    <!-- ++ other accountable accounts > disabled -->
                                                                                    <div
                                                                                        v-else
                                                                                        class="d-flex align-center"
                                                                                    >
                                                                                        <v-tooltip
                                                                                            location="bottom"
                                                                                        >
                                                                                            <template
                                                                                                v-slot:activator="{
                                                                                                    props,
                                                                                                }"
                                                                                            >
                                                                                                <div
                                                                                                    v-bind="
                                                                                                        props
                                                                                                    "
                                                                                                >
                                                                                                    <v-list-item
                                                                                                        disabled
                                                                                                    >
                                                                                                        <v-list-item-title
                                                                                                            width="450px"
                                                                                                        >
                                                                                                            Supprimer
                                                                                                            le
                                                                                                            tableau
                                                                                                            d'amortissement
                                                                                                            et/ou
                                                                                                            la
                                                                                                            sortie
                                                                                                            d'immobilisation
                                                                                                        </v-list-item-title>

                                                                                                        <template
                                                                                                            v-slot:append
                                                                                                        >
                                                                                                            <v-icon
                                                                                                                :color="
                                                                                                                    actionColor(
                                                                                                                        props
                                                                                                                            .item
                                                                                                                            .currentAlAcrData,
                                                                                                                    )
                                                                                                                "
                                                                                                                size="large"
                                                                                                                icon="$oss-trash"
                                                                                                            />
                                                                                                        </template>
                                                                                                    </v-list-item>
                                                                                                </div>
                                                                                            </template>

                                                                                            <!-- ** depreciationTable -->
                                                                                            <template
                                                                                                v-if="
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .depreciationTable &&
                                                                                                    props
                                                                                                        .item
                                                                                                        .currentAlAcrData
                                                                                                        .depreciationTable
                                                                                                        .length
                                                                                                "
                                                                                            >
                                                                                                <span>
                                                                                                    La
                                                                                                    mise
                                                                                                    en
                                                                                                    service
                                                                                                    et
                                                                                                    le
                                                                                                    début
                                                                                                    des
                                                                                                    amortissements
                                                                                                    sont
                                                                                                    dans
                                                                                                    un
                                                                                                    exercice
                                                                                                    clôturé
                                                                                                </span>
                                                                                            </template>

                                                                                            <span
                                                                                                v-else
                                                                                            >
                                                                                                Cas
                                                                                                pas
                                                                                                traité
                                                                                                :
                                                                                                merci
                                                                                                de
                                                                                                remonter
                                                                                                l'information
                                                                                                au
                                                                                                support
                                                                                            </span>
                                                                                        </v-tooltip>
                                                                                    </div>
                                                                                </template>
                                                                            </template>
                                                                        </v-list>
                                                                    </v-menu>
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        <template #body.append>
                                                            <tr style="font-weight: bold">
                                                                <!-- icon -->
                                                                <th />

                                                                <!-- wording -->
                                                                <th>
                                                                    <h3>Totaux</h3>
                                                                </th>

                                                                <!-- date -->
                                                                <th />

                                                                <!-- date linearStartDate (mise en service) -->
                                                                <th />

                                                                <!-- HT -->
                                                                <th style="text-align: right">
                                                                    <h3>
                                                                        {{
                                                                            newCommonFormatCurrency(
                                                                                accAccountTableSums(
                                                                                    invoicesAccountingLinesACRFilter
                                                                                        .filteredIAL[
                                                                                        accAccount
                                                                                    ],
                                                                                    "amountSigned",
                                                                                ),
                                                                                undefined,
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </th>

                                                                <!-- TVA -->
                                                                <th
                                                                    style="
                                                                        text-align: right;
                                                                        border-right: 1px solid
                                                                            #dddddd;
                                                                    "
                                                                >
                                                                    <h3>
                                                                        {{
                                                                            newCommonFormatCurrency(
                                                                                accAccountTableSums(
                                                                                    invoicesAccountingLinesACRFilter
                                                                                        .filteredIAL[
                                                                                        accAccount
                                                                                    ],
                                                                                    "alVatAmountSigned",
                                                                                ),
                                                                                undefined,
                                                                            )
                                                                        }}
                                                                    </h3>
                                                                </th>

                                                                <!-- table -->
                                                                <th />

                                                                <template
                                                                    v-if="switchDepreciationTable"
                                                                >
                                                                    <!-- type -->
                                                                    <th />

                                                                    <!-- durée -->
                                                                    <th />

                                                                    <!-- start -->
                                                                    <th />

                                                                    <!-- end -->
                                                                    <th />

                                                                    <!-- previousDepreciations -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSumsGetPeriodLine(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "previousDepreciations",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>

                                                                    <!-- currentLinearDepreciation -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSumsGetPeriodLine(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "currentLinearDepreciation",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>

                                                                    <!-- currentDerogationDepreciation -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSumsGetPeriodLine(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "currentDerogationDepreciation",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>

                                                                    <!-- accumulatedDepreciations -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSumsGetPeriodLine(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "accumulatedDepreciations",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>

                                                                    <!-- netBookValueEnd -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSumsGetPeriodLine(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "netBookValueEnd",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>
                                                                </template>

                                                                <!-- outflowDate -->
                                                                <th
                                                                    style="
                                                                        border-left: 1px solid
                                                                            #dddddd;
                                                                    "
                                                                />

                                                                <template v-if="switchOutFlowTable">
                                                                    <!-- VNC L - outflowLinearNetBookValue -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSums(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "outflowLinearNetBookValue",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>

                                                                    <!-- sellAmount -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSums(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "sellAmount",
                                                                                    ),
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>

                                                                    <!-- moreOrLessValue -->
                                                                    <th style="text-align: right">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    accAccountTableSums(
                                                                                        invoicesAccountingLinesACRFilter
                                                                                            .filteredIAL[
                                                                                            accAccount
                                                                                        ],
                                                                                        "moreOrLessValue",
                                                                                    ) || 0,
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </th>
                                                                </template>

                                                                <!-- actions -->
                                                                <th
                                                                    style="
                                                                        border-left: 1px solid
                                                                            #dddddd;
                                                                    "
                                                                />
                                                            </tr>
                                                        </template>
                                                    </v-data-table>
                                                </v-expansion-panel-text>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-card>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- ++ consultation section -->
                    <v-card
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 mt-4"
                    >
                        <!-- ** title + arrow -->
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <h3 class="pl-4">Section de consultation</h3>
                                </v-card-title>
                            </v-col>

                            <!-- <v-spacer></v-spacer> -->

                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6" />
                                    <v-col
                                        cols="6"
                                        class="align-center pa-0"
                                        data-cy="AuditConnectedAcrDocuments-documents"
                                    >
                                        <v-btn-icon
                                            :icon="
                                                consultationSectionExpand
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            @click="
                                                consultationSectionExpand =
                                                    !consultationSectionExpand
                                            "
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-card-text v-if="consultationSectionExpand" transition="expand">
                            <v-expansion-panels flat v-model="consultationsPanelInner" multiple>
                                <!-- ** Données de la déclaration amortissement -->
                                <v-expansion-panel value="declarationAccountingLines">
                                    <v-expansion-panel-title class="px-0">
                                        <h3>Données de la déclaration - amortissements</h3>

                                        <template v-slot:actions>
                                            <v-icon> $expand </v-icon>
                                        </template>
                                    </v-expansion-panel-title>

                                    <v-expansion-panel-text>
                                        <div
                                            v-if="
                                                consultationsPanelInner.includes(
                                                    'declarationAccountingLines',
                                                )
                                            "
                                            class="pa-0"
                                        >
                                            <v-card-text v-if="declarationError" class="pa-0">
                                                <div v-html="declarationError" />
                                            </v-card-text>

                                            <v-card-text
                                                v-else-if="
                                                    !declarationAccountingLines ||
                                                    !declarationAccountingLines.length
                                                "
                                            >
                                                <h4>Aucun immobilisation saisie</h4>
                                            </v-card-text>

                                            <template v-else>
                                                <v-data-table
                                                    v-if="
                                                        declarationAccountingLines &&
                                                        declarationAccountingLines.length
                                                    "
                                                    :headers="declarationAccountingLinesHeaders"
                                                    :items="declarationAccountingLines"
                                                    fixed-header
                                                    :items-per-page="-1"
                                                    hide-default-footer
                                                    class="table pb-2"
                                                    max-height="70vh"
                                                    style="border: 1px #ededed solid"
                                                    density="compact"
                                                >
                                                    <template
                                                        v-slot:item.accountableAccountName="{
                                                            item,
                                                        }"
                                                    >
                                                        {{ item.accountableAccountName }}
                                                    </template>

                                                    <template v-slot:item.wording="{ item }">
                                                        {{ item.wording }}
                                                    </template>

                                                    <template v-slot:item.date="{ item }">
                                                        {{ formatDate(item.date) }}
                                                    </template>

                                                    <template v-slot:item.grossAmount="{ item }">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                item.grossAmount,
                                                                undefined,
                                                            )
                                                        }}
                                                    </template>

                                                    <template v-slot:item.vatAmount="{ item }">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                item.vatAmount,
                                                                undefined,
                                                            )
                                                        }}
                                                    </template>

                                                    <template v-slot:item.netAmount="{ item }">
                                                        {{
                                                            newCommonFormatCurrency(
                                                                item.netAmount,
                                                                undefined,
                                                            )
                                                        }}
                                                    </template>

                                                    <template v-slot:item.type="{ item }">
                                                        {{ item.type }}
                                                    </template>

                                                    <template v-slot:item.rate="{ item }">
                                                        {{
                                                            newCommonFormatCurrency(item.rate, {
                                                                currency: "",
                                                            })
                                                        }}
                                                    </template>

                                                    <template
                                                        v-slot:item.previousDepreciations="{ item }"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                item.previousDepreciations,
                                                                undefined,
                                                            )
                                                        }}
                                                    </template>

                                                    <template
                                                        v-slot:item.currentDepreciation="{ item }"
                                                    >
                                                        {{
                                                            newCommonFormatCurrency(
                                                                item.currentDepreciation,
                                                                undefined,
                                                            )
                                                        }}
                                                    </template>

                                                    <template #body.append>
                                                        <tr style="font-weight: bold">
                                                            <th />
                                                            <!-- ** accountableAccountName -->

                                                            <th>Totaux</th>
                                                            <!-- ** wording -->

                                                            <th />
                                                            <!-- ** date -->

                                                            <th style="text-align: right">
                                                                <!-- ** grossAmount -->
                                                                <h3>
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumsTable(
                                                                                declarationAccountingLines,
                                                                                "grossAmount",
                                                                            ),
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </th>

                                                            <th style="text-align: right">
                                                                <!-- ** vatAmount -->
                                                                <h3>
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumsTable(
                                                                                declarationAccountingLines,
                                                                                "vatAmount",
                                                                            ),
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </th>

                                                            <th style="text-align: right">
                                                                <!-- ** netAmount -->
                                                                <h3>
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumsTable(
                                                                                declarationAccountingLines,
                                                                                "netAmount",
                                                                            ),
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </th>

                                                            <th />
                                                            <!-- ** type -->

                                                            <th />
                                                            <!-- ** rate -->

                                                            <th style="text-align: right">
                                                                <!-- ** previousDepreciations -->
                                                                <h3>
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumsTable(
                                                                                declarationAccountingLines,
                                                                                "previousDepreciations",
                                                                            ),
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </th>

                                                            <th style="text-align: right">
                                                                <!-- ** currentDepreciation -->
                                                                <h3>
                                                                    {{
                                                                        newCommonFormatCurrency(
                                                                            sumsTable(
                                                                                declarationAccountingLines,
                                                                                "currentDepreciation",
                                                                            ),
                                                                            undefined,
                                                                        )
                                                                    }}
                                                                </h3>
                                                            </th>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </template>
                                        </div>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>

                                <!-- //  TO DO: declarationOutflowsAccountingLines  -->

                                <!-- ** Etat des dotations aux amortissements comptables sur 10 ans -->
                                <v-expansion-panel
                                    value="estimatedStatementDepreciationAllowances"
                                    class="px-0"
                                >
                                    <v-expansion-panel-title class="px-0">
                                        <h3>
                                            &#xc9;tat des dotations aux amortissements comptables
                                            sur 10 ans
                                        </h3>
                                        <template v-slot:actions>
                                            <v-icon> $expand </v-icon>
                                        </template>
                                    </v-expansion-panel-title>

                                    <v-expansion-panel-text
                                        class="fixed_assets_depreciations__wrapper pa-0"
                                    >
                                        <div
                                            v-if="
                                                consultationsPanelInner.includes(
                                                    'estimatedStatementDepreciationAllowances',
                                                )
                                            "
                                            class="pa-0"
                                        >
                                            <v-card-text
                                                v-if="
                                                    !estimatedStatementDepreciationAllowances ||
                                                    !estimatedStatementDepreciationAllowances[0] ||
                                                    !estimatedStatementDepreciationAllowances[0]
                                                        .accountableAccounts
                                                "
                                            >
                                                <h4>Aucun immobilisation saisie</h4>
                                            </v-card-text>

                                            <template v-else>
                                                <!-- ** accountableAccounts -->
                                                <!-- ** single fixedAssets -->
                                                <v-data-table
                                                    :headers="
                                                        estimatedStatementDepreciationAllowances[0]
                                                            .headers
                                                    "
                                                    :items="
                                                        estimatedStatementDepreciationAllowances
                                                    "
                                                    fixed-header
                                                    :items-per-page="-1"
                                                    hide-default-footer
                                                    density="compact"
                                                    class="table"
                                                    style="border: 1px #ededed solid"
                                                >
                                                    <template v-slot:item="props">
                                                        <template
                                                            v-for="aa in props.item
                                                                .accountableAccounts"
                                                        >
                                                            <!-- ** accountable account name + description -->
                                                            <tr :key="aa.title" v-if="aa.title">
                                                                <td
                                                                    colspan="12"
                                                                    style="
                                                                        background-color: #e1e3eb;
                                                                    "
                                                                >
                                                                    <h4>
                                                                        {{
                                                                            aa.title ||
                                                                            "sans compte"
                                                                        }}
                                                                    </h4>
                                                                </td>
                                                            </tr>

                                                            <!-- ** accountableAccount fixedAssets -->
                                                            <template
                                                                v-if="
                                                                    aa.accAccountFixedAssets &&
                                                                    aa.accAccountFixedAssets.length
                                                                "
                                                            >
                                                                <template
                                                                    v-for="(
                                                                        accAccountFixedAsset, alId
                                                                    ) in aa.accAccountFixedAssets"
                                                                    :key="alId"
                                                                >
                                                                    <!-- // if div is used, key is on the same line, but columns alignment is broken -->
                                                                    <!-- // if template is used, key is not admitted on the same line, but, if put in <tr> columns are OK !! -->
                                                                    <tr class="my-2">
                                                                        <!-- ** 1 col - fixedAssetWording +  -->
                                                                        <td>
                                                                            <template
                                                                                v-if="
                                                                                    !accAccountFixedAsset.someD
                                                                                "
                                                                            >
                                                                                <v-row>
                                                                                    <v-col
                                                                                        class="py-0"
                                                                                        cols="12"
                                                                                    >
                                                                                        {{
                                                                                            accAccountFixedAsset.fixedAssetWording
                                                                                        }}
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </template>

                                                                            <template v-else>
                                                                                <v-row>
                                                                                    <v-col
                                                                                        class="pb-0"
                                                                                    >
                                                                                        {{
                                                                                            accAccountFixedAsset.fixedAssetWording
                                                                                        }}
                                                                                    </v-col>
                                                                                </v-row>

                                                                                <v-row
                                                                                    class="font-italic pa-0 text-caption"
                                                                                >
                                                                                    <v-col
                                                                                        class="py-0"
                                                                                    >
                                                                                        Dont
                                                                                        linéaires
                                                                                    </v-col>
                                                                                </v-row>

                                                                                <v-row
                                                                                    class="font-italic pa-0 text-caption"
                                                                                >
                                                                                    <v-col
                                                                                        class="pt-0"
                                                                                    >
                                                                                        Dont
                                                                                        dérogatoires
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </template>
                                                                        </td>

                                                                        <!-- ** 10 cols - amounts + evtl sub-amounts -->
                                                                        <td
                                                                            v-for="n in 10"
                                                                            :key="n"
                                                                            class="text-right"
                                                                        >
                                                                            <template
                                                                                v-if="
                                                                                    !accAccountFixedAsset.someD
                                                                                "
                                                                            >
                                                                                <v-row>
                                                                                    <v-col
                                                                                        class="py-0"
                                                                                    >
                                                                                        {{
                                                                                            newCommonFormatCurrency(
                                                                                                accAccountFixedAsset[
                                                                                                    `nPlus${
                                                                                                        n -
                                                                                                        1
                                                                                                    }Sum`
                                                                                                ]
                                                                                                    .periodDepreciation,
                                                                                                undefined,
                                                                                            )
                                                                                        }}
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </template>

                                                                            <template v-else>
                                                                                <v-row>
                                                                                    <v-col
                                                                                        class="pb-0"
                                                                                    >
                                                                                        {{
                                                                                            newCommonFormatCurrency(
                                                                                                accAccountFixedAsset[
                                                                                                    `nPlus${
                                                                                                        n -
                                                                                                        1
                                                                                                    }Sum`
                                                                                                ]
                                                                                                    .periodDepreciation,
                                                                                                undefined,
                                                                                            )
                                                                                        }}
                                                                                    </v-col>
                                                                                </v-row>

                                                                                <v-row
                                                                                    class="font-italic pa-0 text-caption"
                                                                                >
                                                                                    <v-col
                                                                                        class="py-0"
                                                                                    >
                                                                                        {{
                                                                                            newCommonFormatCurrency(
                                                                                                accAccountFixedAsset[
                                                                                                    `nPlus${
                                                                                                        n -
                                                                                                        1
                                                                                                    }Sum`
                                                                                                ]
                                                                                                    .linearYearDepreciation,
                                                                                                undefined,
                                                                                            )
                                                                                        }}
                                                                                    </v-col>
                                                                                </v-row>

                                                                                <v-row
                                                                                    class="font-italic pa-0 text-caption"
                                                                                >
                                                                                    <v-col
                                                                                        class="pt-0"
                                                                                    >
                                                                                        {{
                                                                                            newCommonFormatCurrency(
                                                                                                accAccountFixedAsset[
                                                                                                    `nPlus${
                                                                                                        n -
                                                                                                        1
                                                                                                    }Sum`
                                                                                                ]
                                                                                                    .derogationYearDepreciation,
                                                                                                undefined,
                                                                                            )
                                                                                        }}
                                                                                    </v-col>
                                                                                </v-row>
                                                                            </template>
                                                                        </td>
                                                                    </tr>
                                                                </template>
                                                            </template>

                                                            <!-- ** accountableAccounts totals -->
                                                            <tr
                                                                v-if="aa.totals"
                                                                :key="aa.title"
                                                                class="my-2"
                                                            >
                                                                <td
                                                                    style="
                                                                        background-color: #f6f6f6;
                                                                    "
                                                                >
                                                                    <template v-if="!aa.someAaD">
                                                                        <v-row no-gutters>
                                                                            <v-col class="py-0">
                                                                                <h4>
                                                                                    {{
                                                                                        aa.totals
                                                                                            .text
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>

                                                                    <template v-else>
                                                                        <v-row no-gutters>
                                                                            <v-col class="pb-0">
                                                                                <h4>
                                                                                    {{
                                                                                        aa.totals
                                                                                            .text
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>

                                                                        <v-row
                                                                            v-if="aa.linearTotals"
                                                                            class="font-italic pa-0 text-caption"
                                                                            no-gutters
                                                                        >
                                                                            <v-col class="py-0">
                                                                                <h4>
                                                                                    {{
                                                                                        aa
                                                                                            .linearTotals
                                                                                            .text
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>

                                                                        <v-row
                                                                            v-if="
                                                                                aa.derogationTotals
                                                                            "
                                                                            class="font-italic pa-0 text-caption"
                                                                            no-gutters
                                                                        >
                                                                            <v-col class="pt-0">
                                                                                <h4>
                                                                                    {{
                                                                                        aa
                                                                                            .derogationTotals
                                                                                            .text
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                </td>

                                                                <td
                                                                    v-for="n in 10"
                                                                    :key="n"
                                                                    class="text-right"
                                                                    style="
                                                                        background-color: #f6f6f6;
                                                                    "
                                                                >
                                                                    <template v-if="!aa.someAaD">
                                                                        <v-row no-gutters>
                                                                            <v-col class="py-0">
                                                                                <h4>
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            aa
                                                                                                .totals[
                                                                                                "nPlus" +
                                                                                                    (n -
                                                                                                        1) +
                                                                                                    "Sum"
                                                                                            ],
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>

                                                                    <template v-else>
                                                                        <v-row no-gutters>
                                                                            <v-col class="pb-0">
                                                                                <h4>
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            aa
                                                                                                .totals[
                                                                                                "nPlus" +
                                                                                                    (n -
                                                                                                        1) +
                                                                                                    "Sum"
                                                                                            ],
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>

                                                                        <v-row
                                                                            v-if="aa.linearTotals"
                                                                            class="font-italic pa-0 text-caption"
                                                                            no-gutters
                                                                        >
                                                                            <v-col class="py-0">
                                                                                <h4>
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            aa
                                                                                                .linearTotals[
                                                                                                "nPlus" +
                                                                                                    (n -
                                                                                                        1) +
                                                                                                    "Sum"
                                                                                            ],
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>

                                                                        <v-row
                                                                            v-if="
                                                                                aa.derogationTotals
                                                                            "
                                                                            class="font-italic pa-0 text-caption"
                                                                            no-gutters
                                                                        >
                                                                            <v-col class="pt-0">
                                                                                <h4>
                                                                                    {{
                                                                                        newCommonFormatCurrency(
                                                                                            aa
                                                                                                .derogationTotals[
                                                                                                "nPlus" +
                                                                                                    (n -
                                                                                                        1) +
                                                                                                    "Sum"
                                                                                            ],
                                                                                            undefined,
                                                                                        )
                                                                                    }}
                                                                                </h4>
                                                                            </v-col>
                                                                        </v-row>
                                                                    </template>
                                                                </td>
                                                            </tr>
                                                        </template>

                                                        <!-- ** globals -->
                                                        <tr
                                                            v-if="props.item.globals"
                                                            class="py-2"
                                                            style="background-color: #e1e3eb"
                                                        >
                                                            <!-- ** 1 col - fixedAssetWording + evtl sub-titles -->
                                                            <td>
                                                                <template
                                                                    v-if="!props.item.someGlobalD"
                                                                >
                                                                    <v-row no-gutters>
                                                                        <v-col class="pb-0">
                                                                            <h3>
                                                                                {{
                                                                                    props.item
                                                                                        .globals
                                                                                        .text
                                                                                }}
                                                                            </h3>
                                                                        </v-col>
                                                                    </v-row>
                                                                </template>

                                                                <template v-else>
                                                                    <v-row no-gutters>
                                                                        <v-col class="pb-0">
                                                                            <h3>
                                                                                {{
                                                                                    props.item
                                                                                        .globals
                                                                                        .text
                                                                                }}
                                                                            </h3>
                                                                        </v-col>
                                                                    </v-row>

                                                                    <v-row no-gutters>
                                                                        <v-col class="py-0">
                                                                            <h4>
                                                                                {{
                                                                                    props.item
                                                                                        .globalL
                                                                                        .text
                                                                                }}
                                                                            </h4>
                                                                        </v-col>
                                                                    </v-row>

                                                                    <v-row no-gutters>
                                                                        <v-col class="pt-0">
                                                                            <h4>
                                                                                {{
                                                                                    props.item
                                                                                        .globalDerog
                                                                                        .text
                                                                                }}
                                                                            </h4>
                                                                        </v-col>
                                                                    </v-row>
                                                                </template>
                                                            </td>

                                                            <!-- ** 10 cols - amounts + evtl sub-amounts -->
                                                            <td
                                                                v-for="n in 10"
                                                                :key="n"
                                                                class="text-right"
                                                            >
                                                                <v-row no-gutters>
                                                                    <v-col class="pb-0">
                                                                        <h3>
                                                                            {{
                                                                                newCommonFormatCurrency(
                                                                                    props.item
                                                                                        .globals[
                                                                                        `nPlus${
                                                                                            n - 1
                                                                                        }Sum`
                                                                                    ],
                                                                                    undefined,
                                                                                )
                                                                            }}
                                                                        </h3>
                                                                    </v-col>
                                                                </v-row>

                                                                <template
                                                                    v-if="props.item.someGlobalD"
                                                                >
                                                                    <v-row no-gutters>
                                                                        <v-col class="py-0">
                                                                            <h4>
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        props.item
                                                                                            .globalL[
                                                                                            `nPlus${
                                                                                                n -
                                                                                                1
                                                                                            }Sum`
                                                                                        ],
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </h4>
                                                                        </v-col>
                                                                    </v-row>

                                                                    <v-row no-gutters>
                                                                        <v-col class="pt-0">
                                                                            <h4>
                                                                                {{
                                                                                    newCommonFormatCurrency(
                                                                                        props.item
                                                                                            .globalDerog[
                                                                                            `nPlus${
                                                                                                n -
                                                                                                1
                                                                                            }Sum`
                                                                                        ],
                                                                                        undefined,
                                                                                    )
                                                                                }}
                                                                            </h4>
                                                                        </v-col>
                                                                    </v-row>
                                                                </template>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </v-data-table>
                                            </template>
                                        </div>
                                    </v-expansion-panel-text>
                                </v-expansion-panel>
                            </v-expansion-panels>
                        </v-card-text>
                    </v-card>
                </div>

                <!-- ++ documents manually connected to ACR - connectedDocuments -->
                <template v-if="!loading && !dataLoading && inAuditReport">
                    <AuditConnectedAcrDocuments
                        :connectedDocuments="connectedDocuments"
                        :companyId="companyId"
                        :acKey="acKey"
                        :auditCheckResult="auditCheckResult || {}"
                        :accountingPeriodId="accountingPeriodId || undefined"
                        @unlinkedDocument="unlinkDocument($event)"
                        @showLinkedDocument="showLinkedDocument($event)"
                    />
                </template>

                <!-- ++ documents automatically generated (not showed: to many to be showed in fixed assets control) - results -->
                <!-- ** results are too longs and in single accountingLines.acr -->
                <!-- <template v-if="!loading && !dataLoading">
                    <AuditConnectedAcrResults
                        :results="results"
                        :companyId="companyId"
                    ></AuditConnectedAcrResults>
                </template> -->

                <!-- ++ comments -->
                <template
                    v-if="!documentId && !bankTransactionId && !accountingLineId && inAuditReport"
                >
                    <!-- ** longComment -->
                    <v-card
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 mt-4"
                    >
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <h5 class="pl-4">Commentaires détaillés</h5>
                                </v-card-title>
                            </v-col>

                            <!-- <v-spacer></v-spacer> -->

                            <!-- ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6">
                                        <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                    </v-col>

                                    <!-- ** expand icon -->
                                    <v-col cols="6" class="align-center pa-0">
                                        <v-btn-icon
                                            :icon="
                                                longCommentExpand
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            data-cy="CheckFixedAssetsToDepreciate-commentairesDetailles"
                                            @click="longCommentExpand = !longCommentExpand"
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-card-text
                            v-if="longCommentExpand"
                            transition="longCommentExpand"
                            class="pb-0"
                        >
                            <!-- <v-expand-transition no-gutters v-show="longCommentExpand"> -->
                            <v-row class="pt-6">
                                <v-col class="pt-0">
                                    <v-textarea
                                        v-model="longComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                </v-col>
                            </v-row>

                            <v-card-title class="pa-0 text-end">
                                <!-- ** Store data -->
                                <v-btn
                                    class="mt-4"
                                    :disabled="closedPeriod || validated"
                                    rounded
                                    @click.stop="storeComments()"
                                    size="small"
                                >
                                    Enregistrer les commentaires
                                </v-btn>
                            </v-card-title>
                        </v-card-text>
                    </v-card>

                    <!-- ** shortComment -->
                    <v-card
                        elevation="0"
                        style="background-color: white; border-radius: 25px"
                        class="pa-6 mt-4"
                    >
                        <v-row>
                            <v-col cols="11" class="ma-auto">
                                <v-card-title class="ma-0 pa-0">
                                    <h5 class="pl-4">Commentaires synthétiques</h5>
                                </v-card-title>
                            </v-col>

                            <!-- <v-spacer></v-spacer> -->

                            <!-- ** icons *************** -->
                            <v-col cols="1" class="d-flex align-center px-0 justify-center">
                                <v-row>
                                    <v-col cols="6">
                                        <!-- <v-icon v-if="validatedPayrolls"  class="px-2 pt-1" icon="$check_circle" /> -->
                                    </v-col>

                                    <!-- ** expand icon -->
                                    <v-col cols="6" class="align-center pa-0">
                                        <v-btn-icon
                                            :icon="
                                                shortCommentExpand
                                                    ? '$fa-chevron-up'
                                                    : '$fa-chevron-down'
                                            "
                                            @click="shortCommentExpand = !shortCommentExpand"
                                            style="width: 40px"
                                            class="d-inline px-2"
                                        />
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>

                        <v-card-text
                            v-if="shortCommentExpand"
                            transition="shortCommentExpand"
                            class="pb-0"
                        >
                            <v-row class="pt-6">
                                <v-col class="pt-0">
                                    <v-textarea
                                        v-model="shortComment"
                                        :disabled="closedPeriod || validated"
                                        auto-grow
                                        style="border: 1px #ededed solid"
                                        outlined
                                    />
                                </v-col>
                            </v-row>

                            <v-card-title class="pa-0 text-end">
                                <!-- ** Store data -->
                                <v-btn
                                    :disabled="closedPeriod || validated"
                                    class="mt-4"
                                    rounded
                                    @click.stop="storeComments()"
                                    size="small"
                                >
                                    Enregistrer les commentaires
                                </v-btn>
                            </v-card-title>
                        </v-card-text>
                    </v-card>
                </template>

                <!-- ++++++++++++++ DIALOGS ++++++++++++++++++++++ -->

                <!-- ++ import file previous depreciations table -->
                <!-- <v-dialog
                    v-if="currentAlAcrData"
                    @keydown.esc="
                        dialog = false;
                        quitDialog();
                    "
                    v-model="dialog"
                    class="mx-auto"
                    width="70%"
                >
                    <v-card class="uploadDocument">
                        <v-toolbar color="secondary" class="elevation-0">
                            <v-toolbar-title>{{ currentTitle }}</v-toolbar-title>
                            <v-spacer />
                            <v-btn-icon icon="$close" @click="quitDialog" />
                        </v-toolbar>

                        <v-card-text :class="!$vuetify.display.mobile ? '' : 'pa-2'">
                            <CheckFixedAssetsDepreciationTable
                                :parentCurrentAlAcrData="currentAlAcrData"
                                :companyId="companyId"
                                :parentStep="step"
                                :depreciationTypes="filteredDepreciationTypes"
                                :companyFirstPeriod="companyFirstPeriod"
                                :N_1AccountingPeriod="N_1AccountingPeriod"
                                :lastClosedAndFirstOpenAccountingPeriods="
                                    lastClosedAndFirstOpenAccountingPeriods
                                "
                                :onlyShowTable="onlyShowTable"
                                :onlyNaType="onlyNaType"
                                :hideDurationAndStartDate="hideDurationAndStartDate"
                                @quitDepreciationTableDialog="quitDialog"
                            />
                        </v-card-text>
                    </v-card>
                </v-dialog> -->

                <oss-dialog
                    v-if="currentAlAcrData"
                    @keydown.esc="
                        dialog = false;
                        quitDialog();
                    "
                    @close="quitDialog"
                    :title="currentTitle"
                    hide-valid
                    v-model="dialog"
                    min-width="90vw"
                >
                    <CheckFixedAssetsDepreciationTable
                        :parentCurrentAlAcrData="currentAlAcrData"
                        :companyId="companyId"
                        :parentStep="step"
                        :depreciationTypes="filteredDepreciationTypes"
                        :companyFirstPeriod="companyFirstPeriod"
                        :N_1AccountingPeriod="N_1AccountingPeriod"
                        :lastClosedAndFirstOpenAccountingPeriods="
                            lastClosedAndFirstOpenAccountingPeriods
                        "
                        :onlyShowTable="onlyShowTable"
                        :onlyNaType="onlyNaType"
                        :hideDurationAndStartDate="hideDurationAndStartDate"
                        @quitDepreciationTableDialog="quitDialog"
                    />
                </oss-dialog>

                <!-- ++ 1st row (customer, periods, ...) -->
                <!-- ** displayActivityDialog (nested in more_vert icon) -->
                <oss-dialog
                    v-model="displayActivityDialog"
                    v-if="displayActivityDialog"
                    title="Activité"
                    valid-title="Fermer"
                    @valid="displayActivityDialog = false"
                    @close="displayActivityDialog = false"
                    min-width="60vw"
                >
                    <UsersActivitiesHistory
                        :auditCheckKey="acKey"
                        :accountingPeriodId="accountingPeriodId"
                    >
                    </UsersActivitiesHistory>
                </oss-dialog>

                <!-- ** Messages -->
                <Chat
                    :auditCheckAccountingPeriodKey="chatId"
                    v-if="openChat"
                    v-bind:chatTitle="'Chat'"
                />

                <!-- ** uploadDocument - (for connected documents) -->
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckDocumentsManager"
                    v-if="dialogAuditCheckDocumentsManager"
                    :disabled="loading || dataLoading || !accountingPeriod"
                    :companyId="companyId"
                    :documentToDisplay="documentToDisplay"
                    :connectedDocuments="connectedDocuments || []"
                    :acKey="acKey"
                    :auditCheckResult="auditCheckResult || {}"
                    :accountingPeriodId="accountingPeriodId || undefined"
                    :alreadyLinkedDoc="alreadyLinkedDoc"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        alreadyLinkedDoc = false;
                        documentToDisplay = {};
                    "
                />
                <!-- for add document at each line of fixed asset -->
                <AuditCheckDocumentsManager
                    v-model="dialogAuditCheckResultDocumentsManager"
                    v-if="dialogAuditCheckResultDocumentsManager"
                    :disabled="loading || dataLoading"
                    :companyId="companyId"
                    :connectedDocuments="connectedAlAcrDocuments || []"
                    :auditCheckResult="otherAcr || {}"
                    @upsertedAuditCheckResult="upsertedACR"
                    @resetDialogData="
                        otherAcr = {};
                        connectedAlAcrDocuments = [];
                    "
                />

                <!-- Dialog for alAcr documents -->
                <oss-dialog
                    v-if="documentToShow"
                    v-model="displayDocumentToShow"
                    @close="closeDocumentAlAcr"
                    min-width="80vw"
                >
                    <Document
                        v-if="documentToShow"
                        :mode="documentMode"
                        :companyId="companyId"
                        :id="documentToShow.id"
                        :dark-mode="true"
                        :previousIdIsset="previousDocumentIdIsset"
                        :nextIdIsset="nextDocumentIdIsset"
                        :goBackHistory="false"
                        @next="nextDocument"
                        @previous="previousDocument"
                        @deleted-acr="deletedAcrDocument"
                    />
                </oss-dialog>
            </template>
        </div>
    </v-container>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { sumBy, isEmpty, cloneDeep, sortBy } from "lodash";
import { Apollo } from "@/decorators";
import gql from "graphql-tag";

import { decliningBalanceFactor } from "../../../../backend/src/common/audit/auditFunctions";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";
import { getDepreciationDurations } from "../../services/accountingParameters";
import {
    filterWithSelectedAccountingPeriod,
    getLastClosedAndFirstOpenAccountingPeriods,
    getN_1AccountingPeriod,
    isInsideClosedAccountingPeriodAuditReport,
} from "../../services/accountingPeriods";
import {
    closedPeriod,
    createOrDeleteFixedAssetReconciliations,
    generateDepreciationTable,
    generateDocumentsFromAccountingLines,
    formatConnectedDocuments,
} from "../../services/audit/AuditServices";
import { mathFix } from "../../services/mathServices";
import { vatRatesAudit } from "../../services/vatServices";

import AUDIT_ITEMS from "../../graphql/audit/AuditItems.gql";

import DELETE_AUDIT_CHECK_RESULT_AND_RESULTS from "../../graphql/audit/DeleteAuditCheckResultId.gql";
import UPSERT_AUDIT_CHECK_RESULT from "../../graphql/audit/UpsertAuditCheckResultClosure.gql";
import UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT from "../../graphql/audit/UpsertAuditCheckResultConnectExistingDocument.gql";

import { AuditCheckResultDocumentBase } from "@/types/auditCheck.types";
import { Component, Prop, toNative } from "vue-facing-decorator";
import AccountableAccountVue from "../AccountableAccount.vue";
import Chat from "../chat/Chat.vue";
import Document from "../document/DocumentRouter.vue";
import UsersActivitiesHistory from "../UsersActivitiesHistory.vue";
import AuditCheckDocumentsManager from "./AuditCheckDocumentsManager.vue";
import AuditConnectedAcrDocuments from "./AuditConnectedAcrDocuments.vue";
import { CheckBase } from "./CheckBase";
import CheckFixedAssetsDepreciationTable from "./CheckFixedAssetsDepreciationTable.vue";
import GetEmptyDocumentsTable from "./GetEmptyDocumentsTable.vue";

// import AuditConnectedAcrResults from "./AuditConnectedAcrResults.vue"
enum TypeManagementDocument {
    NORMAL_FIXED_ASSET_IN_PROGRESS = 1,
    NORMAL_FIXED_ASSET_CREATED_INTO_BOBBEE = 2,
    FIXED_ASSET_FROM_RECOVERY_NO_DOCUMENT = 3,
    FIXED_ASSET_FROM_RECOVERY_ONE_DOCUMENT = 4,
    FIXED_ASSET_FROM_RECOVERY_MULTI_DOCUMENTS = 5,
}

@Component({
    components: {
        AccountableAccountVue,
        GetEmptyDocumentsTable,
        CheckFixedAssetsDepreciationTable,
        AuditCheckDocumentsManager,
        AuditConnectedAcrDocuments,
        Chat,
        UsersActivitiesHistory,
        Document,
        // AuditConnectedAcrResults
    },
})
export class CheckFixedAssetsToDepreciate extends CheckBase {
    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) documentId: string;
    @Prop({ default: "" }) bankTransactionId: string;
    @Prop({ default: "" }) accountingLineId: string;
    // @Prop({ default: undefined }) panel: Array<number>

    loading: boolean = true;
    dataLoading: boolean = true;
    computeCarryForwardLoading: boolean = false;
    estimatedStatementDepreciationAllowancesLoading: boolean = false;

    dialog: boolean = false;
    dialogCarryForwardCut: boolean = false;
    generateDepreciation: boolean = true;
    outflowDialog: boolean = false;
    dialogAuditCheckDocumentsManager: boolean = false;

    longCommentExpand: boolean = false;
    shortCommentExpand: boolean = false;
    estimatedStatementDepreciationAllowancesExpand: boolean = false;

    longComment: string = "";
    shortComment: string = "";
    validated: boolean = false;

    commentsACRId: string = "";

    selectedDocumentId: string = "";
    objectType: string = "";

    lastClosedPeriodEnd: string = "";
    // startBusinessDate: string = ""

    // auditCheckKey: string = "rIr4hG5NdQWyEnIXvhnYtmmm"

    auditCheckResultId: string = "";
    auditCheckResult: any = null;

    resultDocumentIdsToDelete: Array<any> = [];

    documents: Array<any> = [];
    outflowDocuments: Array<any> = [];
    outflowDocumentsALs: Array<any> = [];
    outflowDocsIdsToDelete: Array<any> = [];

    connectedDocuments: Array<any> = [];
    // results: Array<any> = []
    documentToDisplay: any = {};

    // original: any = {}
    currentAlAcrData: any = {};

    dotAmoType: string = "Dot. Amos - ";

    depreciationType: string = "Linéaire";
    depreciationTypes: Array<any> = ["Linéaire", "Dégressif", "N/A"];

    negatifAmountError: boolean = false;
    negatifAmountErrorDialog: boolean = false;
    someCreditNote: boolean = false;
    someCreditNoteDialog: boolean = false;

    // linearAccountingLines: Array<any> = []
    // decliningAccountingLines: Array<any> = []
    // derogationAccountingLines: Array<any> = []
    // accountingLines: Array<any> = []
    // outflowAccountingLines: Array<any> = []
    reversal28: number = 0;
    reversal145: number = 0;

    // ** Needed to create only documents in open periods
    lastClosedAndFirstOpenAccountingPeriods: any = {};
    firstUnclosedPeriod: any = {};

    N_1AccountingPeriod: any = {};

    // show: boolean = false
    onlyShowTable: boolean = false;
    onlyNaType: boolean = false;
    showCarryForwardCut: boolean = false;
    showDeclarationAccountingLines: boolean = false;
    showEstimatedStatementDepreciationAllowances: boolean = false;

    switchShowDepreciated: boolean = true;
    switchOnlyNewEntry: boolean = false;
    switchOutFlowed: boolean = true;
    switchNA: boolean = true;
    switchDepreciationTable: boolean = false;
    switchOutFlowTable: boolean = false;

    switchOnlyCutPrevious: boolean = false;

    alreadyLinkedDoc: boolean = false;

    storeAccountableAccounts: Array<any> = [];

    hideDurationAndStartDate: boolean = false;

    // #region attr document alacr
    dialogAuditCheckResultDocumentsManager = false;
    otherAcr: object = {};
    documentToShow: AuditCheckResultDocumentBase = null;
    previousDocumentIdIsset = false;
    nextDocumentIdIsset = false;
    documentsAlAcr: AuditCheckResultDocumentBase[] = [];
    connectedAlAcrDocuments: AuditCheckResultDocumentBase[] = [];
    documentMode = "GeneralLedger";
    // #endregion

    mathFix(number) {
        return mathFix(number, 2);
    }

    displayDocumentToShow = false;

    // ** receiving companyId from props
    // get selectedCompany() {
    //     return this.$store.state.selected_company;
    // }

    get inAuditReport() {
        if (this.$route.name === "fixedAssets") {
            return false;
        }
        return true;
    }

    get checkStatus() {
        if (this.validated && this.reviewed === 1) {
            return "Validé par le responsable";
        }
        if (this.validated && this.reviewed === -1) {
            return "Refusé par le responsable";
        }
        if (this.validated && this.reviewed === 0) {
            return "En attente de validation par le responsable";
        }
        if (!this.validated && !this.auditCheckResult) {
            return "A faire";
        }
        if (!this.validated && this.auditCheckResult) {
            return "En cours";
        }
        return "statut manquant";
    }

    get TypeManagementDocument() {
        return TypeManagementDocument;
    }

    /**
     * Check if One item is a cutPrevious alAcr
     */
    get hasCutPreviousAlAcr() {
        if (!this.cutAcrId) {
            return false;
        }

        return Object.entries(this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows).some(
            ([key, value]) => {
                if (Array.isArray(value) && value.length) {
                    return value.some(
                        (item) =>
                            item.currentAlAcrData &&
                            item.currentAlAcrData.documentIsResultOf?.id === this.cutAcrId,
                    );
                }
                return false;
            },
        );
    }

    /**
     * Action for click management document
     */
    openDocumentAlAcr(alAcr: any): void {
        if (!alAcr) return;

        const typeManagementDoc: TypeManagementDocument =
            this.getTypeManagementOfAcrDocument(alAcr);

        switch (typeManagementDoc) {
            case TypeManagementDocument.NORMAL_FIXED_ASSET_IN_PROGRESS:
            case TypeManagementDocument.NORMAL_FIXED_ASSET_CREATED_INTO_BOBBEE: {
                if (alAcr.objectType === "document") {
                    const documents: AuditCheckResultDocumentBase[] = cloneDeep(
                        alAcr.documents || [],
                    );

                    // add acr document in first position
                    documents.unshift({
                        id: alAcr.documentId,
                    });

                    this.showDocumentAlAcr(documents);
                }
                break;
            }
            case TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_NO_DOCUMENT:
                // no action for this type
                break;
            case TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_ONE_DOCUMENT:
            case TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_MULTI_DOCUMENTS:
                this.showDocumentAlAcr(alAcr.documents);
                break;
        }
    }

    /**
     * if we show the action for see the documents
     */
    showAlAcrDocuments(alAcr: any): boolean {
        const typeManagementDoc: TypeManagementDocument =
            this.getTypeManagementOfAcrDocument(alAcr);

        switch (typeManagementDoc) {
            case TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_ONE_DOCUMENT:
            case TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_MULTI_DOCUMENTS:
            case TypeManagementDocument.NORMAL_FIXED_ASSET_IN_PROGRESS:
            case TypeManagementDocument.NORMAL_FIXED_ASSET_CREATED_INTO_BOBBEE:
                return true;

            case TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_NO_DOCUMENT:
                return false;
        }
    }

    /**
     * Get gestion type for the document
     * 1 : normal currently but not validate
     * 2 : normal fixed asset created into bobbee
     * 3 : fixed asset from cutPrevious : no document
     * 4 : fixed asset from cutPrevious : one document
     * 5 : fixed asset from cutPrevious : multi documents
     */
    getTypeManagementOfAcrDocument(alAcr: any): TypeManagementDocument {
        if (this.cutAcrId) {
            if (alAcr.documentIsResultOf?.id === this.cutAcrId) {
                // because of any type of documents we need type length
                switch (alAcr.documents.length as number) {
                    case 0:
                        return TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_NO_DOCUMENT;
                    case 1:
                        return TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_ONE_DOCUMENT;
                    default:
                        // we have more than one document
                        return TypeManagementDocument.FIXED_ASSET_FROM_RECOVERY_MULTI_DOCUMENTS;
                }
            }
            return TypeManagementDocument.NORMAL_FIXED_ASSET_CREATED_INTO_BOBBEE;
        }
        return TypeManagementDocument.NORMAL_FIXED_ASSET_IN_PROGRESS;
    }

    /**
     * Set up the params of the dialog for add document to alAcr
     * @param alAcr : accountingLine acr
     */
    uploadAcrDocument(alAcr: any): void {
        this.otherAcr = {
            id: alAcr.acrId,
        };

        this.connectedAlAcrDocuments = cloneDeep(alAcr.documents || []);

        this.dialogAuditCheckResultDocumentsManager = true;
    }

    /**
     * Call by the next event emit of Document
     */
    nextDocument(): void {
        const currentIndex: number = this.documentsAlAcr.findIndex(
            (d) => d.id === this.documentToShow.id,
        );

        if (currentIndex === -1 || this.documentsAlAcr.length <= 1) {
            return;
        }

        const nextIndex = currentIndex + 1;

        // we are in the array
        if (nextIndex < this.documentsAlAcr.length) {
            this.documentToShow = this.documentsAlAcr[nextIndex];
            this.previousDocumentIdIsset = true;
        }

        if (nextIndex === this.documentsAlAcr.length - 1) {
            this.nextDocumentIdIsset = false;
        }
    }

    /**
     * Call by the prev event emit of Document
     */
    previousDocument(): void {
        const currentIndex: number = this.documentsAlAcr.findIndex(
            (d) => d.id === this.documentToShow.id,
        );

        if (currentIndex === -1 || this.documentsAlAcr.length <= 1) {
            return;
        }

        const previousIndex = currentIndex - 1;

        // we are in the array
        if (previousIndex >= 0) {
            this.documentToShow = this.documentsAlAcr[previousIndex];
            this.nextDocumentIdIsset = true;
        }

        if (previousIndex === 0) {
            this.previousDocumentIdIsset = false;
        }
    }

    /**
     * Call when the task of show document is ended
     */
    deletedAcrDocument(): void {
        this.displayDocumentToShow = false;
        this.upsertedACR();
    }

    /**
     * call when dialog of Document close
     * reset the parameters for the Dialog
     */
    closeDocumentAlAcr(): void {
        this.nextDocumentIdIsset = false;
        this.previousDocumentIdIsset = false;
        this.documentToShow = null;
        this.documentsAlAcr = [];
    }

    /**
     * Open the document in the dialog
     * mode - GeneralLedger : open the document without next/prev
     *      - ToBeDone : open the document with next/prev
     */
    showDocumentAlAcr(documents: AuditCheckResultDocumentBase[]): void {
        if (!documents.length) {
            return;
        }

        this.documentToShow = cloneDeep(documents[0]);
        this.documentsAlAcr = cloneDeep(documents);
        this.documentMode = "GeneralLedger";

        if (this.documentsAlAcr.length > 1) {
            this.documentMode = "ToBeDone";
            this.nextDocumentIdIsset = true;
        }

        this.displayDocumentToShow = true;
    }

    formatDate(date: string) {
        const returnedDate = moment(date).format("DD/MM/YYYY");
        return returnedDate;
    }

    // formatDate23h(date: string) {
    //     const returnedDate =  moment(date).utc(false).format('DD/MM/YYYY')
    //     return returnedDate
    // }

    // ++++ The DatePicker needs a format 'YYYY-MM-DD' +++++
    formatDatePicker(date: string) {
        return moment(date).format("YYYY-MM-DD");
    }

    newCommonFormatCurrency(value, options: any = undefined) {
        return newCommonFormatCurrency(value, options);
    }

    get vatList() {
        // const vats = [
        //     { value: "20", text: '20' },
        //     { value: "10", text: '10' },
        //     { value: "08", text: '8.5' },
        //     { value: "05", text: '5.5' },
        //     { value: "02", text: '2.1' },
        // ]
        return vatRatesAudit;
    }

    get decliningBalanceFactor() {
        return decliningBalanceFactor;
    }

    // dicoDateInClosedAccountingPeriod = {}
    // counter = 0

    inClosedAccountingPeriod(date) {
        // return false

        if (!date) {
            return true;
        }
        if (!moment(date).isValid()) {
            return true;
        }
        if (!this.$store?.state.accountingPeriod?.accountingPeriods?.length) {
            return true;
        }

        const inClosedAP = isInsideClosedAccountingPeriodAuditReport(
            this.$store.state.accountingPeriod.accountingPeriods,
            date,
        );
        return inClosedAP;
    }

    // ++++++++++++ CHECK HEADERS - MISSING SALES-INVOICES +++++++++
    depreciationTableHeaders: Array<any> = [
        {
            // text: "Document",
            title: "",
            value: "",
            key: "",
            align: "start",
            width: "30px",
            sortable: false,
        },
        {
            title: "Libellé",
            value: "fixedAssetWording",
            key: "fixedAssetWording",
            align: "start",
            width: "40vw",
            minWidth: "300px",
        },
        {
            title: "Date achat",
            key: "date",
            align: "center",
            width: "100px",
        },
        {
            title: "Mise en service L",
            value: "linearSpreadStartDate",
            key: "linearSpreadStartDate",
            align: "center",
            width: "120px",
        },
        {
            title: "HT",
            value: "amountSigned",
            key: "amountSigned",
            align: "end",
            width: "auto",
        },
        {
            title: "TVA",
            key: "alVatAmountSigned",
            align: "end",
            width: "auto",
            // style: "border-rigth:solid 1px #DDDDDD"
        },
        {
            title: "Tableau",
            key: "",
            align: "center",
            width: "30px",
        },
        {
            title: "Type",
            key: "linearDepreciation",
            align: "start",
            width: "30px",
            switch: "switchDepreciationTable",
        },
        {
            title: "Durée",
            key: "linearDepreciation",
            align: "start",
            width: "30px",
            switch: "switchDepreciationTable",
        },
        {
            title: "Début",
            key: "linearSpreadStartDate",
            align: "center",
            width: "76px",
            switch: "switchDepreciationTable",
        },
        {
            title: "Fin",
            key: "linearSpreadEndDate",
            align: "center",
            width: "76px",
            switch: "switchDepreciationTable",
        },
        {
            title: "Amos antér.",
            key: "linearNetBookValue0101",
            align: "end",
            width: "auto",
            switch: "switchDepreciationTable",
        },
        {
            title: "Dot. amos L",
            key: "linearYearDepreciation",
            align: "end",
            width: "auto",
            switch: "switchDepreciationTable",
        },
        {
            title: "Dot. amos dérog.",
            key: "derogationYearDepreciation",
            align: "end",
            width: "auto",
            switch: "switchDepreciationTable",
        },
        {
            title: "Cumul amos",
            key: "linearAccumulatedDepreciation",
            align: "end",
            width: "auto",
            switch: "switchDepreciationTable",
        },
        {
            title: "VNC",
            key: "linearAccumulatedDepreciation",
            align: "end",
            width: "auto",
            switch: "switchDepreciationTable",
        },
        {
            title: "Sortie",
            key: "",
            align: "center",
            sortable: true,
            width: "76px",
            // style: "border-left:1px solid #dddddd;"
        },
        {
            title: "VNC L",
            key: "",
            align: "end",
            width: "auto",
            switch: "switchOutFlowTable",
        },
        {
            title: "Prix vente",
            key: "",
            align: "end",
            width: "auto",
            switch: "switchOutFlowTable",
        },
        {
            title: "+/- key (N uniquement)",
            key: "",
            align: "end",
            width: "auto",
            switch: "switchOutFlowTable",
        },
        {
            title: "Actions",
            key: "",
            align: "center",
            width: "auto",
            // style: "border-left:1px solid #dddddd;"
        },
    ];

    // ++++++++++++ depreciation table headers +++++++++
    depreciationHeaders: Array<any> = [
        {
            title: "Année",
            key: "resumePeriodEnd",
            align: "center",
            sortable: false,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
        },
        {
            title: "L - VNC début",
            key: "linearNetBookValue0101",
            align: "end",
            sortable: false,
        },
        {
            title: "L - cumul N-1",
            key: "linearAccumulatedDepreciationStart",
            align: "end",
            sortable: false,
        },
        {
            title: "L - Dot.",
            key: "linearYearDepreciation",
            align: "end",
            sortable: false,
        },
        {
            title: "L - Cumul N",
            key: "linearAccumulatedDepreciation",
            align: "end",
            sortable: false,
        },
        {
            title: "L - VNC Fin",
            key: "linearNetBookValue3112",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            title: "D - VNC 01-01",
            key: "decliningNetBookValue0101",
            align: "end",
            sortable: false,
        },
        {
            title: "D - cumul N-1",
            key: "decliningAccumulatedDepreciationStart",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            title: "D - Dot.",
            key: "decliningYearDepreciation",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            title: "D - Cumul",
            key: "decliningAccumulatedDepreciation",
            align: "end",
            sortable: false,
        },
        {
            title: "D - VNC 31-12",
            key: "decliningNetBookValue3112",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            title: "Dot. dérogatoire",
            key: "derogationYearDepreciation",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
    ];

    declarationAccountingLinesHeaders: Array<any> = [
        {
            title: "Compte",
            key: "accountableAccountName",
            align: "start",
            sortable: true,
            style: "font-weight: bold; border-end:1px solid #dddddd;",
        },
        {
            title: "Nature immos",
            key: "wording",
            align: "start",
            sortable: false,
        },
        {
            title: "Date achat",
            key: "date",
            align: "end",
            sortable: false,
        },
        {
            title: "Prix TTC",
            key: "grossAmount",
            align: "end",
            sortable: false,
        },
        {
            title: "TVA déduite",
            key: "vatAmount",
            align: "end",
            sortable: false,
        },
        {
            title: "Valeur HT",
            key: "netAmount",
            align: "end",
            sortable: false,
            style: "border-end:1px solid #dddddd;",
        },
        {
            title: "Mode",
            key: "type",
            align: "end",
            sortable: false,
        },
        {
            title: "Taux",
            key: "rate",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            title: "Amos antér.",
            key: "previousDepreciations",
            align: "end",
            sortable: false,
            style: "font-weight: bold",
        },
        {
            title: "Amos N",
            key: "currentDepreciation",
            align: "end",
            sortable: false,
        },
    ];

    beforeMount() {
        this._mounted();
        // ** Needs all accountingPeriods attibutes to create only documents in open periods
        this.searchAccountingPeriod();

        if (this?.$store?.state?.accountingPeriod?.accountingPeriods) {
            this.accountingPeriods = this?.$store?.state?.accountingPeriod?.accountingPeriods || [];

            if (this.accountingPeriods?.length > 1) {
                this.N_1AccountingPeriod = getN_1AccountingPeriod(
                    this?.$store?.state?.accountingPeriod as any,
                    this.accountingPeriodId,
                );
            }
        }

        if (!this.accountingPeriods?.length) {
            return;
        } else {
            this.lastClosedAndFirstOpenAccountingPeriods =
                getLastClosedAndFirstOpenAccountingPeriods(this.accountingPeriods);

            if (this.lastClosedAndFirstOpenAccountingPeriods) {
                this.firstUnclosedPeriod =
                    this.lastClosedAndFirstOpenAccountingPeriods.firstUnclosedPeriod;
            }
        }

        if (this.$store.state.accountableAccountTable.accountableAccounts) {
            this.storeAccountableAccounts =
                this.$store.state.accountableAccountTable?.accountableAccounts;
        }
    }

    afterAccountingPeriodFound() {}

    // ***********************************************************
    // ********** APOLLO - INVOICES LIST - NETAMOUNT OVER 500€ ***
    @Apollo({
        query: AUDIT_ITEMS,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.acKey,
                accountingPeriodId: this.accountingPeriodId,
                documentId: this.documentId || undefined,
                bankTransactionId: this.bankTransactionId || undefined,
                accountingLineId: this.accountingLineId || undefined,
            };
        },
        skip() {
            return (
                !this.companyId ||
                !this.accountingPeriodId ||
                !this?.$store?.state?.accountingPeriod
            );
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading && data) {
                this.dataLoading = true;
                if (data && data.auditItems && data.auditItems.items && data.auditItems.items[0]) {
                    this.hideDurationAndStartDate = false;
                    this.localPanel = this.localPanel.length ? this.localPanel : [];
                    this.consultationsPanel = this.consultationsPanel.length
                        ? this.consultationsPanel
                        : [];
                    this.workSectionExpand = !this.workSectionExpand ? false : true;
                    this.consultationSectionExpand = !this.consultationSectionExpand ? false : true;
                    this.auditItems = JSON.parse(JSON.stringify(data.auditItems.items[0]));

                    if (this.auditItems) {
                        this.cutAcrId = this.auditItems?.cutAcrId || null;
                        if (this.auditItems.lastSituationDateYYYYMMDD) {
                            this.lastSituationDateYYYYMMDD =
                                this.auditItems.lastSituationDateYYYYMMDD;
                        }

                        if (this.auditItems.declarationAccountingLines) {
                            this.declarationAccountingLines =
                                this.auditItems.declarationAccountingLines;
                        }

                        if (this.auditItems.declarationError) {
                            this.declarationError = this.auditItems.declarationError?.error || null;
                        }

                        this.negatifAmountError = this.auditItems.negatifAmountError || false;

                        this.someCreditNote = this.auditItems.someCreditNote || false;

                        if (this.auditItems.declarationOutflowsAccountingLines) {
                            this.declarationOutflowsAccountingLines =
                                this.auditItems.declarationOutflowsAccountingLines;
                        }

                        if (!isEmpty(this.auditItems.estimatedStatementDepreciationAllowances)) {
                            this.estimatedStatementDepreciationAllowances =
                                this.auditItems.estimatedStatementDepreciationAllowances;
                        }

                        this.companyFirstPeriod = this.auditItems.companyFirstPeriod?.start
                            ? this.auditItems.companyFirstPeriod
                            : {};

                        this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows =
                            this.auditItems
                                .groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows || {};
                        if (
                            Object.keys(
                                this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows,
                            ).length === 1
                        ) {
                            this.localPanel.push(0);
                        }

                        if (!this.documentId && !this.bankTransactionId && !this.accountingLineId) {
                            if (!isEmpty(this.auditItems.commentsACR)) {
                                this.auditCheckResult = this.auditItems.commentsACR;
                                this.commentsACRId = this.auditCheckResult.id || "";
                                this.longComment =
                                    this.auditCheckResult.data?.[0]?.longComment || "";
                                this.shortComment =
                                    this.auditCheckResult.data?.[0]?.shortComment || "";
                                this.validated =
                                    this.auditCheckResult.data?.[0]?.validated || false;

                                if (this.auditCheckResult?.documents?.length) {
                                    this.connectedDocuments = this.auditCheckResult.documents;
                                }

                                if (this.auditCheckResult.reviewed) {
                                    this.reviewed = this.auditCheckResult.reviewed;
                                }

                                // ** results are too longs and in single accountingLines.acr
                                // if (this.auditCheckResult.results) {
                                //     this.results = this.auditCheckResult.results
                                // }
                            } else {
                                this.commentsACRId = "";
                                this.longComment = "";
                                this.shortComment = "";
                                this.validated = false;
                            }
                        }
                        this.loading = false;
                    }
                } else {
                    this.estimatedStatementDepreciationAllowances = {};
                    this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows = {};
                    this.commentsACRId = "";
                    this.longComment = "";
                    this.shortComment = "";
                }
                this.dataLoading = false;
            }
        },
    })
    auditItems: any = null;

    cutAcrId: string = null;

    groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows: any = {};

    companyFirstPeriod: any = {};

    estimatedStatementDepreciationAllowances: any = {};

    lastSituationDateYYYYMMDD: string = undefined;

    reviewed: number = 0;

    localPanel: Array<any> = [];
    consultationsPanel: Array<any> = [];
    consultationsPanelInner: Array<any> = [];

    estimatedStatementDepreciationAllowancesPanel: Array<any> = [];

    declarationAccountingLines: Array<any> = null;

    declarationError: string = null;

    declarationOutflowsAccountingLines: Array<any> = [];

    workSectionExpand: boolean = true;

    consultationSectionExpand: boolean = false;

    // ** switch filter - with or without acr
    // // TODO: check in data AL array
    get invoicesAccountingLinesACRFilter(): any {
        if (
            this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows &&
            !isEmpty(this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows)
        ) {
            if (
                this.switchShowDepreciated === true &&
                this.switchOutFlowed === true &&
                this.switchNA === true &&
                this.switchOnlyNewEntry === false &&
                !this.switchOnlyCutPrevious
            ) {
                const accountableAccounts = Object.keys(
                    this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows,
                );
                const sortedAccountableAccounts = sortBy(accountableAccounts);

                return {
                    filteredIAL: this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows,
                    sortedAccountableAccounts: sortedAccountableAccounts,
                };
            } else {
                let filteredIAL = {};

                for (const accAccount in this
                    .groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows) {
                    const groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows = JSON.parse(
                        JSON.stringify(
                            this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows[
                                accAccount
                            ],
                        ),
                    );
                    let filtered = groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows;

                    if (!this.switchShowDepreciated) {
                        filtered = filtered.filter(
                            (ial) =>
                                !ial.currentAlAcrData?.depreciationTable?.length ||
                                ial.currentAlAcrData?.modifiedInvoiceToRegenerate,
                        );
                    }

                    if (this.switchOnlyNewEntry) {
                        filtered = filtered.filter((ial) =>
                            filterWithSelectedAccountingPeriod(
                                this.accountingPeriod,
                                ial.currentAlAcrData?.date,
                            ),
                        );
                    }

                    if (!this.switchOutFlowed) {
                        filtered = filtered.filter((ial) => !ial.currentAlAcrData?.outflowDate);
                    }

                    if (!this.switchNA) {
                        filtered = filtered.filter((ial) => ial.currentAlAcrData?.type !== "N/A");
                    }

                    if (this.switchOnlyCutPrevious) {
                        filtered = filtered.filter(
                            (ial) =>
                                ial.currentAlAcrData &&
                                ial.currentAlAcrData.documentIsResultOf?.id === this.cutAcrId,
                        );
                    }

                    if (filtered?.length) {
                        filteredIAL[accAccount] = filtered;
                    }
                }
                const accountableAccounts = Object.keys(filteredIAL);
                const sortedAccountableAccounts = sortBy(accountableAccounts);

                return {
                    filteredIAL: filteredIAL,
                    sortedAccountableAccounts: sortedAccountableAccounts,
                };
            }
        }
        return {};
    }

    // **************** ICON : DOCUMENT VIEW *****************
    openObject(documentId, objectType) {
        if (this.accountingLineId) {
            this.$router.push({
                name: "accountingLine",
                params: {
                    companyId: this.companyId,
                    id: this.accountingLineId,
                },
            });
        } else if (objectType === "document") {
            this.$router.push({
                name: "document",
                params: {
                    companyId: this.companyId,
                    id: documentId,
                },
            });
        } else if (objectType === "bankTransaction") {
            this.$router.push({
                name: "reconciliation",
                params: {
                    companyId: this.companyId,
                    bankTransactionId: documentId,
                },
            });
        } else {
            debugger; // git-ignore
        }
    }

    // ************ V-WINDOW **************
    step: string = "";

    get currentTitle() {
        switch (this.step) {
            case "generateDepreciationStep":
                return !isEmpty(this.currentAlAcrData)
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Saisie des éléments`
                    : "Saisie des éléments";
            case "outflowStep":
                return !isEmpty(this.currentAlAcrData)
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Sortie de l'immobilisation`
                    : "Sortie de l'immobilisation";
            case "tableStep":
                return !isEmpty(this.currentAlAcrData)
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Détail de l'immobilisation`
                    : "Détail de l'immobilisation";
            default:
                return `Détail de l'immobilisation`;
        }
    }

    get currentCarryForwardCutTitle() {
        switch (this.step) {
            case "singleOrMultipleChoice":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Saisie des éléments`
                    : "Saisie des éléments";
            case "outflowStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Sortie de l'immobilisation`
                    : "Sortie de l'immobilisation";
            case "tableStep":
                return Object.keys(this.currentAlAcrData).length
                    ? `${this.currentAlAcrData.fixedAssetWording.replace(
                          this.currentAlAcrData.dotAmoType,
                          "",
                      )} - Détail de l'immobilisation`
                    : "Détail de l'immobilisation";
            default:
                return `Détail de l'immobilisation`;
        }
    }

    quitDialog() {
        this.dialog = false;
        this.generateDepreciation = true;
        this.documents = [];
        this.resultDocumentIdsToDelete = [];
        this.currentAlAcrData = {};
        this.onlyShowTable = false;
        this.onlyNaType = false;
        this.dotAmoType = "Dot. Amos - ";
        this.step = "";
        this.selectedDocumentId = "";
        this.objectType = "";
        this.hideDurationAndStartDate = false;
        // this.inAccountingPeriod = {}
        // this.switchShowDepreciated = true

        this.refresh();
    }

    refresh() {
        const panel = this.localPanel || [];
        const consultationsPanel = this.consultationsPanel || [];
        const consultationsPanelInner = this.consultationsPanelInner || [];
        const workSectionExpand = !this.workSectionExpand ? false : true;
        const consultationSectionExpand = !this.consultationSectionExpand ? false : true;
        const estimatedStatementDepreciationAllowancesPanel =
            this.estimatedStatementDepreciationAllowancesPanel || [];
        if (this.$apollo.queries && this.$apollo.queries.auditItems) {
            this.$apollo.queries.auditItems.refetch();
        } else {
            // eslint-disable-next-line
            debugger; // git-ignore
        }
        this.estimatedStatementDepreciationAllowancesPanel =
            estimatedStatementDepreciationAllowancesPanel;
        this.workSectionExpand = workSectionExpand;
        this.consultationSectionExpand = consultationSectionExpand;
        this.localPanel = panel;
        this.consultationsPanel = consultationsPanel;
        this.consultationsPanelInner = consultationsPanelInner;
    }

    upsertedACR() {
        this.refresh();
    }

    unlinkDocument(id) {
        this.connectedDocuments = this.connectedDocuments?.filter((document) => document.id !== id);
    }

    showLinkedDocument(id) {
        this.documentToDisplay = { id };
        this.alreadyLinkedDoc = true;
        this.dialogAuditCheckDocumentsManager = true;
    }

    // ** only shows depreciationTable
    async openOnlyShowDialog(data2) {
        this.onlyShowTable = true;
        this.openDialog(data2);
    }

    // **************** OPEN DIALOG *****************
    async openDialog(data2) {
        // ** props.item = {
        // **    currentAlAcrData: {},
        // ** }
        let currentAlAcrData: any = JSON.parse(JSON.stringify(data2.currentAlAcrData));

        this.selectedDocumentId = currentAlAcrData.documentId;
        this.objectType = currentAlAcrData.objectType;

        if (this.onlyShowTable && data2.currentAlAcrData?.depreciationTable?.length) {
            this.currentAlAcrData = data2.currentAlAcrData;
            this.step = "tableStep";
        } else if (this.onlyNaType) {
            this.currentAlAcrData = data2.currentAlAcrData;
            this.step = "setTypeNaOnClosedPeriod";
        } else {
            if (currentAlAcrData.depreciationTable?.length && !currentAlAcrData.results?.length) {
                const { dataAccountingLines, results } =
                    await this.queryCurrentAlAcrDataResultsAndDataAls(currentAlAcrData);
                currentAlAcrData.results = results;
                currentAlAcrData.accountingLines = dataAccountingLines;
            }

            this.depreciationType =
                currentAlAcrData.type && currentAlAcrData.type === "N/A"
                    ? "N/A"
                    : currentAlAcrData.linearDepreciation
                      ? this.depreciationTypes[0]
                      : this.depreciationTypes[1];

            if (
                !currentAlAcrData.yearDuration ||
                !Object.keys(currentAlAcrData.yearDuration).length
            ) {
                if (
                    currentAlAcrData.accountableAccount &&
                    currentAlAcrData.accountableAccount.name
                ) {
                    currentAlAcrData.yearDuration =
                        currentAlAcrData.yearDuration ||
                        getDepreciationDurations().find((dr) =>
                            dr.name.startsWith(
                                currentAlAcrData.accountableAccount.name.slice(0, 4),
                            ),
                        );

                    currentAlAcrData.selectedYearDuration = currentAlAcrData.selectedYearDuration
                        ? currentAlAcrData.selectedYearDuration
                        : currentAlAcrData.yearDuration?.defaultYearDuration
                          ? currentAlAcrData.yearDuration.defaultYearDuration
                          : 0;
                }
            }

            this.currentAlAcrData = currentAlAcrData;
        }
        // this.step = 'generateDepreciationStep'
        this.dialog = true;
    }

    async storeComments(action = undefined) {
        const commentsACRKey = this.acKey + "_" + this.companyId + "_" + this.accountingPeriodId;

        const data = [
            {
                shortComment: this.shortComment || "",
                longComment: this.longComment || "",
                validated: this.validated || false,
            },
        ];

        const upsertVariables: any = {
            id: this.commentsACRId || "",
            key: commentsACRKey,
            companyId: this.companyId,
            status: this.validated ? "VALIDATED" : "EDITION",
            thirdPartyCompanyCreate: undefined,
            thirdPartyCompanyUpdate: undefined,
            accountingPeriodCreate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            accountingPeriodUpdate: this.accountingPeriodId
                ? { connect: { id: this.accountingPeriodId } }
                : undefined,
            // deleteDocuments: [], // ** previous results, if to delete
            // documents: [],  // ** results = générés par le contrôle
            connectDocuments: formatConnectedDocuments(this.connectedDocuments), // ** docs liés
            auditCheckKey: this.acKey,
            data: data,
            type: "IN_AUDIT_REPORT",
            reviewed: this.reviewed,
        };

        // eslint-disable-next-line no-await-in-loop
        const storedComments: any = await this.$apollo.mutate({
            mutation: UPSERT_AUDIT_CHECK_RESULT,
            variables: upsertVariables,
        });

        // await this.createUserActivity(action) // deprecated

        this.refresh();
    }

    async validateFunction() {
        if (!this.validated) {
            this.validated = !this.validated;
            await this.storeComments("VALIDATE");
        } else {
            this.validated = !this.validated;
            this.reviewed = 0;
            await this.storeComments("UPDATE");
        }
    }

    // ***************** DELETE ACR **********************
    async deleteAuditCheckResult(acrId) {
        if (!acrId) {
            return;
        }
        const result = await this.$apollo.mutate({
            mutation: DELETE_AUDIT_CHECK_RESULT_AND_RESULTS,
            variables: { id: acrId },
        });

        // await this.createUserActivity("DELETE") // deprecated

        this.refresh();
    }

    async deletePeriodNOutFlow(currentAlAcrData) {
        if (
            currentAlAcrData.outflowDate?.length &&
            !this.inClosedAccountingPeriod(currentAlAcrData.outflowDate)
        ) {
            if (!currentAlAcrData.results?.length) {
                // ** ACR results and data.accountingLines are heavy and required only if necessary
                const { dataAccountingLines, results } =
                    await this.queryCurrentAlAcrDataResultsAndDataAls(currentAlAcrData);
                currentAlAcrData.results = results;
                currentAlAcrData.accountingLines = dataAccountingLines;
            }

            let reconciliationsDeletePromises: Array<Promise<any>>;
            if (currentAlAcrData.results?.length) {
                const promises = await createOrDeleteFixedAssetReconciliations(
                    this.$apollo,
                    currentAlAcrData,
                    currentAlAcrData.results,
                    "DELETE_RECONCILIATION",
                    this.companyId,
                );
                // 'CREATE_RECONCILIATION',

                if (promises?.promises?.length) {
                    reconciliationsDeletePromises = promises.promises;
                } else if (promises?.error) {
                    console.error(promises.error);
                    debugger;
                }
            }

            const isNA = currentAlAcrData.type === "N/A";
            const fullDepreciatedBeforeOutflowDate =
                !isNA &&
                currentAlAcrData.linearSpreadEndDate &&
                currentAlAcrData.depreciationTable?.length
                    ? currentAlAcrData.outflowDate > currentAlAcrData.linearSpreadEndDate
                    : true;

            const linearSpreadEndDateEqualOutflowDate =
                currentAlAcrData.linearSpreadEndDate == currentAlAcrData.outflowDate;

            // ** isole les documents de la date de sortie (dernier amortissement partiel + sortie immo)
            let outflowResults = currentAlAcrData.results?.filter(
                (dr) =>
                    moment(dr.date).format("YYYY-MM-DD") ==
                    moment(currentAlAcrData.outflowDate).format("YYYY-MM-DD"),
            );
            if (!outflowResults?.length) {
                console.error(
                    "En cas de sortie d'immobilisation, il devrait y avoir au moins 1 ACR.result à la date de sortie",
                );
                debugger;
            }
            let deleteOutflowResultIds = outflowResults.map((dr) => dr.id);

            let documentsToRebuild = [];

            if (isNA) {
                // ** pas d'amortissements, ni depreciationTable
                // ** le seul ACR.result devrait être celui de sortie
                if (deleteOutflowResultIds.length != 1) {
                    console.error(
                        "En cas de type N/A, le seul ACR.result devrait être celui de sortie",
                    );
                    debugger;
                }
            } else {
                // ** type L ou D
                if (fullDepreciatedBeforeOutflowDate) {
                    // ** déjà complètement amorti à la date de sortie
                    // ** le seul ACR.result devrait être celui de sortie
                    if (deleteOutflowResultIds.length != 1) {
                        console.error(
                            "En cas d'immo complétement amortie, les seuls ACR.results devrait être ceux de sortie + (si sortie en cours de mois) la dernière dot. amo partielle",
                        );
                        debugger;
                    }
                } else if (linearSpreadEndDateEqualOutflowDate) {
                    // ** la dernière dotation aux amos est de la date de sortie
                    // ** le seul ACR.result à supprimer est celui contenant "sortie"
                    outflowResults = outflowResults.filter((or) =>
                        or.accountingLines?.[0]?.wording.includes("sortie"),
                    );
                    deleteOutflowResultIds = outflowResults.map((dr) => dr.id);
                    if (deleteOutflowResultIds.length != 1) {
                        console.error(
                            "En cas d'immo complétement amortie, les seuls ACR.results devrait être ceux de sortie",
                        );
                        debugger;
                    }
                } else {
                    // ** amortissement en cours à la date de sortie
                    // ** il faut supprimer les 2 documents de la date de sortie
                    // ** - le document de sortie
                    // ** - s'il existe, le dernier amortissement partiel
                    if (!outflowResults.length || outflowResults.length > 2) {
                        console.error(
                            "En cas de sortie d'immobilisation, il devrait y avoir au plus 2 ACR.results à la date de sortie",
                        );
                        debugger;
                    }

                    // ** Il faut ré-créer / calculer
                    // ** - les dot. amos depuis le début du mois complet de sortie, jusqu'à la date de fin d'amortissement(linearSpreadEndDate)
                    // ** - la depreciationTable
                    const accountingLinesToRebuild = currentAlAcrData.accountingLines.filter(
                        (al) => al.date > currentAlAcrData.outflowDate,
                    );
                    documentsToRebuild = await generateDocumentsFromAccountingLines(
                        currentAlAcrData.fixedAssetWording,
                        accountingLinesToRebuild,
                        this.companyId,
                        this.currentUser.id,
                        this.$apollo,
                    );

                    // // est-ce que currentAlAcrData contient declingAccountingLines et derogationAccountingLines ?
                    // // autre question : accountingLines
                    currentAlAcrData.depreciationTable = await generateDepreciationTable(
                        currentAlAcrData,
                        currentAlAcrData.accountingLines,
                        [], // ** decliningAccountingLines
                        [], // ** derogationAccountingLines,
                        currentAlAcrData.depreciableAmountSigned || currentAlAcrData.amountSigned, // ** depreciationsBasis
                        this.accountingPeriod,
                    );
                }

                currentAlAcrData.results = [];
                currentAlAcrData.outflowDate = undefined;
                currentAlAcrData.outflowLinearNetBookValue = undefined;
                currentAlAcrData.sellAmount = undefined;
                currentAlAcrData.sellVatAmount = undefined;
                currentAlAcrData.sellVatRate = undefined;
                currentAlAcrData.moreOrLessValue = undefined;

                const upsertVariables = {
                    id: currentAlAcrData.acrId || "",
                    auditCheckKey: this.acKey,
                    key:
                        this.acKey +
                        "_" +
                        this.companyId +
                        "_" +
                        currentAlAcrData.documentId +
                        "_" +
                        currentAlAcrData.alId,
                    companyId: this.companyId,
                    status: "UNKNOWN",
                    thirdPartyCompanyCreate:
                        currentAlAcrData.thirdPartyCompany && currentAlAcrData.thirdPartyCompany.id
                            ? { connect: { id: currentAlAcrData.thirdPartyCompany.id } }
                            : undefined,
                    thirdPartyCompanyUpdate:
                        currentAlAcrData.thirdPartyCompany && currentAlAcrData.thirdPartyCompany.id
                            ? { connect: { id: currentAlAcrData.thirdPartyCompany.id } }
                            : undefined,
                    // documentCreateConnection: !BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                    documentCreateConnection: undefined,
                    // documentUpdateConnection: !BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                    documentUpdateConnection: undefined,
                    accountingLineCreateConnection: { connect: { id: currentAlAcrData.alId } },
                    accountingLineUpdateConnection: { connect: { id: currentAlAcrData.alId } },
                    // bankTransactionCreateConnection: BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                    bankTransactionCreateConnection: undefined,
                    // bankTransactionUpdateConnection: BT ? {connect: {id: currentAlAcrData.documentId}} : undefined,
                    bankTransactionUpdateConnection: undefined,
                    deleteDocuments: deleteOutflowResultIds,
                    documents: documentsToRebuild,
                    data: currentAlAcrData || [],
                };

                if (reconciliationsDeletePromises?.length) {
                    try {
                        const promisesDone = await Promise.all(reconciliationsDeletePromises);
                    } catch (e) {
                        console.error("Error while reconciliations:" + e);
                    }
                }

                await this.$apollo.mutate({
                    mutation: UPSERT_AUDIT_CHECK_RESULT__CONNECT_EXISTING_DOCUMENT,
                    variables: upsertVariables || {},
                });

                // await this.createUserActivity("UPDATE") // deprecated
            }
        }

        this.quitDialog();
    }

    // async computeCarryForward() {
    //     if (this.N_1AccountingPeriod?.id && this.N_1AccountingPeriod?.closed) {
    //         this.computeCarryForwardLoading = true
    //         await this.$apollo.mutate({
    //             mutation: COMPUTE_CARRY_FORWARD,
    //             variables: {
    //                 accountingPeriodId: this.N_1AccountingPeriod.id,
    //                 companyId: this.companyId,
    //             }
    //         })
    //         this.computeCarryForwardLoading = false
    //     }
    // }

    actionColor(currentAlAcrData) {
        if (currentAlAcrData.modifiedInvoiceToRegenerate) {
            return "red";
        }
        return "primary";
    }

    actionColorNegativeAmount(amountSigned) {
        if (amountSigned < 0) {
            return "text-right text-red";
        }
        return "text-right";
    }

    changeDotAmoType() {
        if (this.depreciationType?.length) {
            if (this.depreciationType === "N/A") {
                this.currentAlAcrData.type = "N/A";
                this.currentAlAcrData.yearDuration = 0;
                this.currentAlAcrData.rate = 0;
                this.currentAlAcrData.selectedYearDuration = 0;
            } else {
                this.currentAlAcrData.type = this.depreciationType;
                this.currentAlAcrData.linearDepreciation =
                    this.depreciationType && this.depreciationType === "Linéaire" ? true : false;
                this.currentAlAcrData.dotAmoType = this.currentAlAcrData.linearDepreciation
                    ? "Dot. Amos - L - "
                    : "Dot. Amos - D - ";
            }
        }
    }

    minMaxRules(globalVatAmountSigned) {
        return [
            (v) =>
                parseInt(v) <= globalVatAmountSigned ||
                "Valeur maximale " + [globalVatAmountSigned] + "€",
            (v) => parseInt(v) >= 0 || "Valeur minimale >= 0",
        ];
    }

    // ** only needed in ToDepreciate
    getPeriodLine(alAcrData) {
        const depreciationTable = cloneDeep(alAcrData.depreciationTable);
        let periodLine: any = {};
        let periodLineData: any = {};

        if (depreciationTable?.length) {
            periodLine = depreciationTable.find(
                (dt) =>
                    dt.resumePeriodEnd === moment(this.accountingPeriod.end).format("YYYY-MM-DD"),
            );

            if (!periodLine) {
                if (
                    depreciationTable[0].resumePeriodEnd >
                    moment(this.accountingPeriod.end).format("YYYY-MM-DD")
                ) {
                    periodLineData = {
                        previousDepreciations: 0,
                        currentLinearDepreciation: 0, // ** no currentLinearDepreciation
                        currentDerogationDepreciation: 0, // ** no currentDerogationDepreciation
                        accumulatedDepreciations: 0,
                        netBookValueEnd: alAcrData.alNetAmountSigned || 0,
                    };
                } else {
                    periodLine = depreciationTable[depreciationTable.length - 1];

                    periodLineData = {
                        previousDepreciations:
                            periodLine.decliningAccumulatedDepreciation ||
                            periodLine.linearAccumulatedDepreciation ||
                            0,
                        currentLinearDepreciation: 0, // ** no currentLinearDepreciation
                        currentDerogationDepreciation: 0, // ** no currentDerogationDepreciation
                        accumulatedDepreciations:
                            periodLine.decliningAccumulatedDepreciation ||
                            periodLine.linearAccumulatedDepreciation ||
                            0,
                        netBookValueEnd:
                            periodLine.decliningNetBookValue3112 ||
                            periodLine.linearNetBookValue3112 ||
                            0,
                    };
                }
            } else {
                periodLineData = {
                    previousDepreciations: periodLine.decliningAccumulatedDepreciationStart
                        ? mathFix(periodLine.decliningAccumulatedDepreciationStart, 2)
                        : periodLine.linearAccumulatedDepreciationStart
                          ? mathFix(periodLine.linearAccumulatedDepreciationStart, 2)
                          : 0,
                    currentLinearDepreciation: periodLine.linearYearDepreciation || 0,
                    currentDerogationDepreciation: periodLine.derogationYearDepreciation || 0,
                    accumulatedDepreciations: periodLine.decliningAccumulatedDepreciation
                        ? mathFix(periodLine.decliningAccumulatedDepreciation, 2)
                        : periodLine.linearAccumulatedDepreciation
                          ? mathFix(periodLine.linearAccumulatedDepreciation, 2)
                          : 0,
                    netBookValueEnd: periodLine.decliningNetBookValue3112
                        ? mathFix(periodLine.decliningNetBookValue3112, 2)
                        : periodLine.linearNetBookValue3112
                          ? mathFix(periodLine.linearNetBookValue3112, 2)
                          : 0,
                };
            }
        } else {
            // ** no depreciationTable
            periodLineData = {
                previousDepreciations: 0,
                currentLinearDepreciation: 0, // ** no currentLinearDepreciation
                currentDerogationDepreciation: 0, // ** no currentDerogationDepreciation
                accumulatedDepreciations: 0,
                netBookValueEnd: alAcrData.alNetAmountSigned || 0,
            };
        }

        return periodLineData;
    }

    accAccountTableSums(accAccount, key) {
        if (accAccount && accAccount.length > 0) {
            // return accAccount.reduce((a, b) => a + (b[key] || 0), 0)
            if (!["moreOrLessValue", "sellAmount", "outflowLinearNetBookValue"].includes(key)) {
                return sumBy(accAccount, (aa: any) => {
                    return aa.currentAlAcrData[key];
                });
            }
            return sumBy(accAccount, (aa: any) => {
                return aa.currentAlAcrData.outflowDate &&
                    aa.currentAlAcrData.outflowDate <=
                        this.formatDatePicker(this.accountingPeriod.end)
                    ? aa.currentAlAcrData[key]
                    : 0;
            });
        }
        return 0;
    }

    accAccountTableSumsGetPeriodLine(accAccount, key) {
        if (accAccount && accAccount.length > 0) {
            let sum = 0;
            for (const aa of accAccount) {
                if (
                    aa.currentAlAcrData &&
                    aa.currentAlAcrData.depreciationTable &&
                    aa.currentAlAcrData.depreciationTable.length
                ) {
                    sum += this.getPeriodLine(aa.currentAlAcrData)[key] || 0;
                }
            }
            return sum;
        }
        return 0;
    }

    // ** dialog
    disabledNextBtn(currentAlAcrData) {
        if (!isEmpty(currentAlAcrData)) {
            if (currentAlAcrData.type && currentAlAcrData.type === "N/A") {
                return false;
            }
            if (
                currentAlAcrData.selectedYearDuration &&
                currentAlAcrData.selectedYearDuration > 0 &&
                currentAlAcrData.linearSpreadStartDate &&
                moment(currentAlAcrData.linearSpreadStartDate).isValid()
            ) {
                return false;
            }
        }
        return true;
    }

    // ** utilisé seulement si !currentAlAcrData.depreciationTable?.length
    showGenerateTableBtn(currentAlAcrData) {
        if (
            (currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date) &&
            this.inClosedAccountingPeriod(
                currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date,
            )
        ) {
            return false;
        }
        // if (currentAlAcrData?.type === 'N/A') {
        //     return false
        // }
        if (currentAlAcrData.outflowDate?.length) {
            return false;
        }
        if (currentAlAcrData.wording?.startsWith("Reprise")) {
            return false;
        }
        return true;
    }

    // ** oss-data-table
    showOnlyNAGenerateTableBtn(currentAlAcrData: any) {
        if (
            this.isIntangibleOrFinancialFixedAsset(currentAlAcrData.aaNameFixedAsset?.name) &&
            this.cutAcrId &&
            this.accountingPeriods?.length &&
            (currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date) &&
            this.inClosedAccountingPeriod(
                currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date,
            ) &&
            !currentAlAcrData.acrId // ** pas de acrId = pas de sortie
        ) {
            return true;
        }
        return false;
    }

    // ** oss-data-table
    showModifyTypeNAAndGenerateTableBtn(currentAlAcrData) {
        if (currentAlAcrData?.type === "N/A") {
            if (
                !currentAlAcrData.depreciationTable?.length &&
                this.accountingPeriods?.length &&
                (currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date) &&
                !this.inClosedAccountingPeriod(
                    currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date,
                ) &&
                !currentAlAcrData.outflowDate
            ) {
                return true;
            }
            return false;
        }
        return false;
    }

    // ** oss-data-table
    showOutFlowBtn(currentAlAcrData) {
        if (this.accountingPeriod?.closed) {
            return false;
        }
        if (!currentAlAcrData?.outflowDate?.length) {
            if (currentAlAcrData?.type && currentAlAcrData.type === "N/A") {
                return true;
            }
            if (currentAlAcrData?.depreciationTable?.length) {
                return true;
            }
        }
        return false;
    }

    showNABtn(currentAlAcrData) {
        if (
            currentAlAcrData?.aaNameFixedAsset?.name?.startsWith("20") ||
            currentAlAcrData?.aaNameFixedAsset?.name?.startsWith("27")
        ) {
            // ** si cutPrevious dèjà fait
            if (!currentAlAcrData?.type || currentAlAcrData.type !== "N/A") {
                if (!currentAlAcrData?.depreciationTable?.length) {
                    if (this.accountingPeriods?.length) {
                        if (
                            (currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date) &&
                            this.inClosedAccountingPeriod(
                                currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date,
                            )
                        ) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }

    // ** oss-data-table  more_vert - 1
    // showModifyTableBtn(currentAlAcrData) {
    //     // debugger
    //     if (currentAlAcrData.outflowDate?.length) {
    //         return false
    //     }
    //     if (currentAlAcrData.type === 'N/A') {
    //         return false
    //     }
    //     if (!this.accountingPeriods?.length) {
    //         return false
    //     }
    //     if (!currentAlAcrData.depreciationTable?.length) {
    //         return false
    //     }
    //     if (this.inClosedAccountingPeriod(currentAlAcrData.date)) {
    //         return false
    //     }
    //     return true
    // }

    // modifyTableBtnTooltip(currentAlAcrData) {
    //     // debugger
    //     if (currentAlAcrData.outflowDate?.length) {
    //         return "L'immobilisation est sortie"
    //     }
    //     if (!this.accountingPeriods?.length) {
    //         return "Aucun exercice comptable"
    //     }
    //     if (currentAlAcrData.type === 'N/A') {
    //         return "L'immobilisation est de type N/A"
    //     }
    //     if (!currentAlAcrData.depreciationTable?.length) {
    //         return "Le tableau d'amortissement n'a pas été généré"
    //     }
    //     if ((currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date) && this.inClosedAccountingPeriod(currentAlAcrData.linearSpreadStartDate || currentAlAcrData.date)) {
    //         return "L'immobilisation est dans un exercice comptable clos"
    //     }
    //     return true
    // }

    // ** oss-data-table  more_vert
    // showDeleteAcrBtn(currentAlAcrData) {
    //     debugger
    //     if (currentAlAcrData.outflowDate?.length) {
    //         return false
    //     }
    //     if (currentAlAcrData.linearSpreadStartDate) {
    //         const linearSpreadStartDateInClosedAccountingPeriod = !currentAlAcrData.linearSpreadStartDate || this.inClosedAccountingPeriod(currentAlAcrData.linearSpreadStartDate)
    //         if (!linearSpreadStartDateInClosedAccountingPeriod) {
    //             return true
    //         }
    //     }
    //     return false
    // }

    // showDepreciationTableAndOutFlowDeleteBtn(currentAlAcrData) {
    //     if (!currentAlAcrData.type ||
    //         currentAlAcrData.type !== 'N/A' &&
    //         currentAlAcrData.depreciationTable?.length &&
    //         currentAlAcrData.outflowDate?.length &&
    //         this.accountingPeriods?.length
    //     ) {
    //         const linearSpreadStartDateInClosedAccountingPeriod = !currentAlAcrData.linearSpreadStartDate || this.inClosedAccountingPeriod(currentAlAcrData.linearSpreadStartDate)
    //         const outflowDateInClosedAccountingPeriod = this.inClosedAccountingPeriod(currentAlAcrData.outflowDate)
    //         if (!linearSpreadStartDateInClosedAccountingPeriod && !outflowDateInClosedAccountingPeriod) {
    //             return true
    //         }
    //     }
    //     return false
    // }

    // ** oss-data-table  more_vert
    // showOutflowDeleteBtnPeriodN(outflowDate) {
    //     debugger
    //     if (outflowDate &&
    //         this.accountingPeriods?.length &&
    //         !this.inClosedAccountingPeriod(outflowDate)
    //     ) {
    //         return true
    //     }
    //     return false
    // }

    // ** oss-data-table   - 2
    // ++ action TODO
    // showOutFlowDeleteBtnLinearSpreadStartDateInCLosedAP(currentAlAcrData) {
    //     if (currentAlAcrData.outflowDate && currentAlAcrData.depreciationTable?.length) {
    //         if (!this.inClosedAccountingPeriod(currentAlAcrData.outflowDate) ) {
    //             return true
    //         }
    //     }
    //     return false
    // }

    // get dataTableHeight() {
    //     return "min(" + (48 * (this.currentAlAcrData.depreciationTable.length + 2)) + "px, 30vh)"
    // }

    get disabledBtnGlobalValidation() {
        if (this.accountingPeriod?.closed) {
            return true;
        }

        if (
            this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows &&
            !isEmpty(this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows)
        ) {
            if (this.negatifAmountError) {
                return true;
            }
            let booleanDepreciatedFixedAsset = false;
            for (const group in this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows) {
                booleanDepreciatedFixedAsset =
                    this.groupedInvoiceAccountingLinesWithoutPreviousYearsOutflows[group].some(
                        (fa) =>
                            !fa.currentAlAcrData?.depreciationTable?.length &&
                            fa.currentAlAcrData?.type !== "N/A",
                    );

                if (booleanDepreciatedFixedAsset) {
                    if (this.validated) {
                        this.validated = false;
                        this.storeComments();
                    }
                    return true;
                }
            }
        }
        return false;
    }

    get closedPeriod() {
        // ** ce contrôle est affiché seulement si une période est sélectionnée
        if (this.accountingPeriod) {
            return closedPeriod(this.accountingPeriod);
        }
        // ** pas la peine de tester avec getLastClosedAndFirstOpenAccountingPeriods()
        return false;
    }

    get switchHeaders() {
        let filteredHeaders = cloneDeep(this.depreciationTableHeaders);
        if (!this.switchDepreciationTable) {
            filteredHeaders = filteredHeaders.filter((h) => h.switch !== "switchDepreciationTable");
        }
        if (!this.switchOutFlowTable) {
            filteredHeaders = filteredHeaders.filter((h) => h.switch !== "switchOutFlowTable");
        }
        return filteredHeaders;
    }

    get filteredDepreciationTypes() {
        if (this.hideDurationAndStartDate) {
            return ["N/A"];
        }

        return this.depreciationTypes;
    }

    sumsTable(table, key) {
        // sum data in give key (property)
        const sumSigned = table?.reduce((a, b) => a + (b[key] || 0), 0);
        return sumSigned;
    }

    isIntangibleOrFinancialFixedAsset(accountableAccountName) {
        // ** immo incorporelle ou financière
        return accountableAccountName?.startsWith("20") || accountableAccountName?.startsWith("27");
    }

    async queryCurrentAlAcrDataResultsAndDataAls(currentAlAcrData) {
        const query = await this.$apollo.query({
            query: gql`
                query auditCheckResult($id: ID!) {
                    auditCheckResult(where: { id: $id }) {
                        id
                        data
                        results {
                            id
                            date
                            accountingLines {
                                id
                                date
                                wording
                                amount
                                amountSigned
                                accountableAccount {
                                    name
                                }
                                reconciliation {
                                    id
                                }
                            }
                        }
                    }
                }
            `,
            variables: {
                id: currentAlAcrData.acrId,
            },
        });

        let dataAccountingLines;
        let results;
        if (query?.data?.auditCheckResult) {
            dataAccountingLines =
                cloneDeep(query.data.auditCheckResult.data?.accountingLines) || [];
            results = cloneDeep(query.data.auditCheckResult.results) || [];
        }
        return {
            dataAccountingLines: dataAccountingLines,
            results: results,
        };
    }
}

export default toNative(CheckFixedAssetsToDepreciate);
</script>

<style lang="scss">
// ** not scoped but limited to class1 followed by class2
// .fixed-width100 {
//     width: 100px; /* Ajustez cette valeur selon vos besoins pour correspondre aux largeurs des headers */
// }

// .fixed-width300 {
//     width: 300px; /* Ajustez cette valeur selon vos besoins pour correspondre aux largeurs des headers */
// }

.fixed_assets_depreciations__wrapper > .v-expansion-panel-text__wrapper {
    padding-left: 0px !important;
    padding-right: 0px !important;
}
</style>
